// 2026 Topps Chrome Star Wars — authored by hand (2026-09-29, the day before
// release on September 30, 2026)
// =============================================================================
// SOURCES: two official Topps checklist PDFs (card lists only — like every
// Topps checklist they name NO parallels), extracted with macOS PDFKit:
// "CheckList_26SWCM_VERSION-2-" (63 pp.) and the NEWER "26SWCM_Checklist.pdf"
// (31 pp., hosted by Blowout Cards, Sep 2026), which is authoritative where
// they differ. Parallel ladders from Checklist Insider's 2026 page, cross-
// checked against Cardsmiths' Value-box listing (every insert, Aurebesh and
// autograph ladder agrees) and Topps RIPPED's box guide. PRE-RELEASE: specimen-
// check once product is out.
// NEWER TOPPS FILE vs VERSION 2 (applied 2026-09-29): Jeremy Allen White
// (A-JAW and MAG-JAW, Rotta the Hutt) REMOVED — also absent from Cardsmiths
// and Collector Nation's counts (Checklist Insider still has him, from the
// older file); the three show autograph sets renamed "... Autograph
// Parallel"; HothFractor renamed "Hoth FrozenFractor"; 10 OVERSIZED HEADS UP
// DIECUT cards CDC-21..30 added — Costco-only per Blowout, so they belong to a
// 2026 Costco set, NOT this file. A-FM Faye Marsay (Vel Sartha) is in BOTH
// files; the first build missed her because her line was glued to a page
// footer in the Version 2 text layer — never filter footer lines wholesale.
//
// PDF TEXT FIXES: the "ff" ligature extracted as "L" in three sketch artists
// (Christoffer Allen Victoria, Jeff Ward, Jeffrey C. Benitez — spellings match
// CK's earlier sets); GMAX-CHEWIE's line was run together; Topps' header typos
// GALATIC / GALAXYS / CHARACHTERS corrected in titles. "DEBUT" suffixes are
// stripped from names, as in 2025.
//
// BASE (1-200) + two full-checklist companions that keep Topps' printed
// prefixes: AUREBESH (AURE-n; Gold /50 .. Superfractor) and PRINTING PLATE BOOK
// CARDS (PLATE-n; 1/1, Hobby/Breaker Delight — no ladder, as in 2025).
// HOTH FROZENFRACTOR is a base PARALLEL /5, not a sub-set (2026-10-23): Topps'
// checklist lists "HOTH-n", but the physical card prints the BASE number and
// base CODE#CMP139852, with an ordinary N/5 front serial (specimens 2/5, 3/5,
// 5/5) and an ice-blue tinted front. The HOTH-n sub-set held no collector
// entries when it was folded into the base ladder.
// The Aurebesh base itself is serial /99, as in 2025 (Cardsmiths lists it as
// plain "Base", but a collector's cards confirm /99, 2026-10-04) — rule-6
// blank-name slot `base` added so the serial can be recorded.
// The first base parallel is "Rainbow Refractor" per Topps RIPPED's box guide
// and Cardsmiths (Checklist Insider says plain "Refractor"; id kept as
// `refractor`). The base ladder includes the Breaker Delight Geometric parallels
// (Skywalker Blue + Purple unnumbered, Orange /25, Black /10, Red /5), the
// Hobby-only Star Wars LogoFractor /77 and the Blaster-only RayWave.
//
// INSERTS: codes as printed. Andor Season 2 Characters mixes A2- and AS-
// prefixes (AS-K2, AS-MON) — that is how Topps printed it. KL-21..30,
// R-16..20 and VC-16..20 continue 2025's Kyber Light / Reflections /
// ComicFractor numbering. V3-9 "Black" is as printed (low confidence).
//
// AUTOGRAPHS: name = signer, artist = character (2026 Galaxy convention).
// ⚠️ Topps printed two codes twice: A-BB (Blair Bess / Even Piell, and
// Benjamin Bratt / Bail Organa) and A-LM (Lars Mikkelsen / Thrawn, and Bronte
// Carmichael). The second of each is CK-keyed A-BB-2 / A-LM-2 until a card
// back shows the real code (keys are immutable once collected — note any
// correction here rather than renaming). The PDF gives Bronte Carmichael no
// character; Leida Mothma is CK-supplied from her TRIP-GAB line. A-RO's
// "Runai Scudlen" is Topps' misspelling of base #34 Runai Sculdun (fixed).
// Singles are unnumbered (ladder starts Green /99). The Andor Season 2, Mando
// & Grogu and Visions Season 3 "Autograph Parallel" sets carry the same
// Green /99 .. Superfractor ladder as the singles per Cardsmiths (Checklist
// Insider still says TBA); Topps RIPPED separately confirms Diego Luna's
// Andor Superfractor 1/1.
// MANDO & GROGU AUTOS print the Characters insert's number and CODE#CMP139942
// (real backs 2026-10-23: Pedro Pascal = MAGR-MAN, Steve Blum = MAGR-ZEB, not
// the PDF's MAG-PP / MAG-SB — renumbered, no collector entries existed).
// Andor (A2A-) and Visions (V3A-) autos are likely the same — unverified.
// DUO (22) / TRIPLE (19): Red /5 + Superfractor per Checklist Insider.
// TODO (rule 7): base serial runs unknown (2025 trio was /10, 2026 Galaxy
// triple /5). Cardsmiths lists both bases as plain "Base" (unnumbered) —
// single source; no blank slot until a specimen states otherwise.
//
// SKETCHES: 173 artists (PDF roster = Checklist Insider's), Silver / Gold /
// Black Foil 1/1 as in 2025.
// =============================================================================

export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 200 CARDS',
    parallels: [{id:'refractor',name:'Rainbow Refractor',print_run:null,color:'#dfe6f0'},{id:'prism-refractor',name:'Prism Refractor',print_run:null,color:'#d4d1e8'},{id:'black-and-white-shimmer-refractor',name:'Black & White Shimmer Refractor',print_run:null,color:'#e8e8ec'},{id:'raywave-refractor',name:'RayWave Refractor',print_run:null,color:'#6cef4d'},{id:'skywalker-blue-geometric-refractor',name:'Skywalker Blue Geometric Refractor',print_run:null,color:'#8fb4ff'},{id:'purple-geometric-refractor',name:'Purple Geometric Refractor',print_run:null,color:'#cb7dff'},{id:'kamino-refractor',name:'Kamino Refractor',print_run:199,color:'#bb8ce4'},{id:'skywalker-blue-refractor',name:'Skywalker Blue Refractor',print_run:150,color:'#7ba2ff'},{id:'kashyyyk-green-refractor',name:'Kashyyyk Green Refractor',print_run:99,color:'#5fd35f'},{id:'star-wars-logofractor',name:'Star Wars LogoFractor',print_run:77,color:'#ffe27a'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'orange-geometric-refractor',name:'Orange Geometric Refractor',print_run:25,color:'#ffb072'},{id:'rebel-orange-wave-refractor',name:'Rebel Orange Wave Refractor',print_run:25,color:'#ffc48f'},{id:'galaxy-refractor',name:'Galaxy Refractor',print_run:15,color:'#7fd8e8'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'black-geometric-refractor',name:'Black Geometric Refractor',print_run:10,color:'#b8b8c4'},{id:'black-mustafar-lava-refractor',name:'Black Mustafar Lava Refractor',print_run:10,color:'#c98f82'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'red-geometric-refractor',name:'Red Geometric Refractor',print_run:5,color:'#ff806b'},{id:'dathomir-wave-refractor',name:'Dathomir Wave Refractor',print_run:5,color:'#ff9090'},{id:'hoth-frozenfractor',name:'Hoth FrozenFractor',print_run:5,color:'#a8d8ff'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'1', name:'Obi-Wan Kenobi', artist:null},
      {n:'2', name:'Lezine', artist:null},
      {n:'3', name:'Chopper', artist:null},
      {n:'4', name:'Devon Izara', artist:null},
      {n:'5', name:'Wizzich Mozzer', artist:null},
      {n:'6', name:'General Maximilian Veers', artist:null},
      {n:'7', name:'Rune Haako', artist:null},
      {n:'8', name:'Tusken Raider Warrior', artist:null},
      {n:'9', name:'Baylan Skoll', artist:null},
      {n:'10', name:'Captain Kaido', artist:null},
      {n:'11', name:'Freck', artist:null},
      {n:'12', name:'Clone Captain Rex', artist:null},
      {n:'13', name:'Sy Snootles', artist:null},
      {n:'14', name:'Chewbacca', artist:null},
      {n:'15', name:'Rabé', artist:null},
      {n:'16', name:'Hamato Xiono', artist:null},
      {n:'17', name:'Ahsoka Tano', artist:null},
      {n:'18', name:'Davo Sculdun', artist:null},
      {n:'19', name:'At Attin frogdog', artist:null},
      {n:'20', name:'Icarus', artist:null},
      {n:'21', name:'Ezra Bridger', artist:null},
      {n:'22', name:'General Hux', artist:null},
      {n:'23', name:'Ben Quadinaros', artist:null},
      {n:'24', name:'Bo-Katan Kryze', artist:null},
      {n:'25', name:'Looti Vario', artist:null},
      {n:'26', name:'Sergeant Heert', artist:null},
      {n:'27', name:'Mace Windu', artist:null},
      {n:'28', name:'Nooma', artist:null},
      {n:'29', name:'General Grievous', artist:null},
      {n:'30', name:'Maz Kanata', artist:null},
      {n:'31', name:'Rey', artist:null},
      {n:'32', name:'Grogu', artist:null},
      {n:'33', name:'Grand Admiral Thrawn', artist:null},
      {n:'34', name:'Runai Sculdun', artist:null},
      {n:'35', name:'Hutt Sister', artist:null},
      {n:'36', name:'Ralakili', artist:null},
      {n:'37', name:'Mace Windu', artist:null},
      {n:'38', name:'Poe Dameron', artist:null},
      {n:'39', name:'Moff Gideon', artist:null},
      {n:'40', name:'Hera Syndulla', artist:null},
      {n:'41', name:'Senator Oran', artist:null},
      {n:'42', name:'The Armorer', artist:null},
      {n:'43', name:'Qi\'ra', artist:null},
      {n:'44', name:'Yoda', artist:null},
      {n:'45', name:'BB-8', artist:null},
      {n:'46', name:'D-O', artist:null},
      {n:'47', name:'The Mandalorian', artist:null},
      {n:'48', name:'Sabine Wren', artist:null},
      {n:'49', name:'Supervisor Lonni Jung', artist:null},
      {n:'50', name:'Vult Skerris', artist:null},
      {n:'51', name:'Dryden Vos', artist:null},
      {n:'52', name:'Anakin Skywalker', artist:null},
      {n:'53', name:'Finn', artist:null},
      {n:'54', name:'Colonel Aftab Ackbar', artist:null},
      {n:'55', name:'Zeb Orrelios', artist:null},
      {n:'56', name:'Shin Hati', artist:null},
      {n:'57', name:'Kylo Ren', artist:null},
      {n:'58', name:'Kanan Jarrus', artist:null},
      {n:'59', name:'Sidon Ithano', artist:null},
      {n:'60', name:'Klatooinian Crime Boss', artist:null},
      {n:'61', name:'Eedy Karn', artist:null},
      {n:'62', name:'Babu Frik', artist:null},
      {n:'63', name:'Cobb Vanth', artist:null},
      {n:'64', name:'Morgan Elsbeth', artist:null},
      {n:'65', name:'Ghorman Spider', artist:null},
      {n:'66', name:'Emperor Palpatine', artist:null},
      {n:'67', name:'Sergeant Gharial', artist:null},
      {n:'68', name:'Colonel Ward', artist:null},
      {n:'69', name:'Bobbajo', artist:null},
      {n:'70', name:'Haja Estree', artist:null},
      {n:'71', name:'Syril Karn', artist:null},
      {n:'72', name:'Commissioner Helgait', artist:null},
      {n:'73', name:'Erskin Semaj', artist:null},
      {n:'74', name:'Jyn Erso', artist:null},
      {n:'75', name:'Hype Fazon', artist:null},
      {n:'76', name:'Rook Kast', artist:null},
      {n:'77', name:'Scorn', artist:null},
      {n:'78', name:'Bix Caleen', artist:null},
      {n:'79', name:'Kuiil', artist:null},
      {n:'80', name:'Captain Enoch', artist:null},
      {n:'81', name:'Stekan Sculdun', artist:null},
      {n:'82', name:'Chirrut Îmwe', artist:null},
      {n:'83', name:'Han Solo', artist:null},
      {n:'84', name:'Imperial Inquisitor', artist:null},
      {n:'85', name:'Lieutenant Connix', artist:null},
      {n:'86', name:'Rose Tico', artist:null},
      {n:'87', name:'The Duchess of Plazir', artist:null},
      {n:'88', name:'Great Mother Lakesis', artist:null},
      {n:'89', name:'Drash', artist:null},
      {n:'90', name:'Jan Dodonna', artist:null},
      {n:'91', name:'Luke Skywalker', artist:null},
      {n:'92', name:'Niro', artist:null},
      {n:'93', name:'Captain Phasma', artist:null},
      {n:'94', name:'Jedi Master Sol', artist:null},
      {n:'95', name:'Omera', artist:null},
      {n:'96', name:'Vel Sartha', artist:null},
      {n:'97', name:'Kleya Marki', artist:null},
      {n:'98', name:'Huyang', artist:null},
      {n:'99', name:'Moff Tarkin', artist:null},
      {n:'100', name:'Bardi', artist:null},
      {n:'101', name:'Asajj Ventress', artist:null},
      {n:'102', name:'Supreme Leader Snoke', artist:null},
      {n:'103', name:'The Stranger', artist:null},
      {n:'104', name:'Captain Gilad Pellaeon', artist:null},
      {n:'105', name:'Cassian Andor', artist:null},
      {n:'106', name:'Pix the Tooka', artist:null},
      {n:'107', name:'Jace Rucklin', artist:null},
      {n:'108', name:'Ponda Baba', artist:null},
      {n:'109', name:'Raxshir', artist:null},
      {n:'110', name:'Noti', artist:null},
      {n:'111', name:'Jedi Master Indara', artist:null},
      {n:'112', name:'Hutt Brother', artist:null},
      {n:'113', name:'Mon Mothma', artist:null},
      {n:'114', name:'Leida Mothma', artist:null},
      {n:'115', name:'Dedra Meero', artist:null},
      {n:'116', name:'Owen Lars', artist:null},
      {n:'117', name:'Yaddle', artist:null},
      {n:'118', name:'Lovey', artist:null},
      {n:'119', name:'Massiff', artist:null},
      {n:'120', name:'Elia Kane', artist:null},
      {n:'121', name:'K-2SO', artist:null},
      {n:'122', name:'General Draven', artist:null},
      {n:'123', name:'Jod Na Nawood', artist:null},
      {n:'124', name:'Count Dooku', artist:null},
      {n:'125', name:'Bossk', artist:null},
      {n:'126', name:'Dobbu Scay', artist:null},
      {n:'127', name:'Imperial Remnant Snowtrooper', artist:null},
      {n:'128', name:'Ranzar "Ran" Malk', artist:null},
      {n:'129', name:'Luthen Rael', artist:null},
      {n:'130', name:'Bail Organa', artist:null},
      {n:'131', name:'Neel', artist:null},
      {n:'132', name:'Padmé Amidala', artist:null},
      {n:'133', name:'Zorii Bliss', artist:null},
      {n:'134', name:'Admiral Ackbar', artist:null},
      {n:'135', name:'Embo', artist:null},
      {n:'136', name:'Jawa', artist:null},
      {n:'137', name:'Saw Gerrera', artist:null},
      {n:'138', name:'Cinta Kaz', artist:null},
      {n:'139', name:'SM-33', artist:null},
      {n:'140', name:'Lyco Strata', artist:null},
      {n:'141', name:'Master Eeko-Dio Daki', artist:null},
      {n:'142', name:'Tallie Lintra', artist:null},
      {n:'143', name:'8D8', artist:null},
      {n:'144', name:'Greef Karga', artist:null},
      {n:'145', name:'Jabba the Hutt', artist:null},
      {n:'146', name:'Maul', artist:null},
      {n:'147', name:'Beela', artist:null},
      {n:'148', name:'Taun We', artist:null},
      {n:'149', name:'BDX Droid', artist:null},
      {n:'150', name:'Captain Peavey', artist:null},
      {n:'151', name:'Jedi Padawan Jecki Lon', artist:null},
      {n:'152', name:'Dreena', artist:null},
      {n:'153', name:'Supervisor Lagret', artist:null},
      {n:'154', name:'Beef', artist:null},
      {n:'155', name:'Luminara Unduli', artist:null},
      {n:'156', name:'Gatori', artist:null},
      {n:'157', name:'Captain Canady', artist:null},
      {n:'158', name:'Omega', artist:null},
      {n:'159', name:'Samm', artist:null},
      {n:'160', name:'Krrsantan', artist:null},
      {n:'161', name:'Spybot', artist:null},
      {n:'162', name:'Barriss Offee', artist:null},
      {n:'163', name:'B-1 Mercenary Droid', artist:null},
      {n:'164', name:'Jar Jar Binks', artist:null},
      {n:'165', name:'Boba Fett', artist:null},
      {n:'166', name:'Enza Rylanz', artist:null},
      {n:'167', name:'Clem Andor', artist:null},
      {n:'168', name:'Bubbles', artist:null},
      {n:'169', name:'C-3PO', artist:null},
      {n:'170', name:'Aayla Secura', artist:null},
      {n:'171', name:'Darth Maul', artist:null},
      {n:'172', name:'Cad Bane', artist:null},
      {n:'173', name:'Perrin Fertha', artist:null},
      {n:'174', name:'B2EMO', artist:null},
      {n:'175', name:'L3-37', artist:null},
      {n:'176', name:'Darth Vader', artist:null},
      {n:'177', name:'Plo Koon', artist:null},
      {n:'178', name:'Qui-Gon Jinn', artist:null},
      {n:'179', name:'Fennec Shand', artist:null},
      {n:'180', name:'Carro Rylanz', artist:null},
      {n:'181', name:'Brander Lawson', artist:null},
      {n:'182', name:'Hugo Durant', artist:null},
      {n:'183', name:'Leia Organa', artist:null},
      {n:'184', name:'Even Piell', artist:null},
      {n:'185', name:'Captain Typho', artist:null},
      {n:'186', name:'B-2 Mercenary Droid', artist:null},
      {n:'187', name:'Oathkeeper', artist:null},
      {n:'188', name:'Keibu', artist:null},
      {n:'189', name:'Gerdis', artist:null},
      {n:'190', name:'Lando Calrissian', artist:null},
      {n:'191', name:'Eleventh Brother', artist:null},
      {n:'192', name:'Vane', artist:null},
      {n:'193', name:'Mrs. Ikk', artist:null},
      {n:'194', name:'Dr. Royce Hemlock', artist:null},
      {n:'195', name:'Lord Janu', artist:null},
      {n:'196', name:'Droopy McCool', artist:null},
      {n:'197', name:'R2-D2', artist:null},
      {n:'198', name:'Oppo Rancisis', artist:null},
      {n:'199', name:'The Grand Inquisitor', artist:null},
      {n:'200', name:'Rotta the Hutt', artist:null},
    ],
  },
  {
    id: 'aurebesh-short-print', type: 'insert', title: 'AUREBESH — 200 CARDS',
    // Base Aurebesh is serial /99: blank-name rule-6 slot renders as "#'d /99".
    parallels: [{id:'base',name:'',print_run:99,color:'#c8d8f0'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'AURE-1', name:'Obi-Wan Kenobi', artist:null},
      {n:'AURE-2', name:'Lezine', artist:null},
      {n:'AURE-3', name:'Chopper', artist:null},
      {n:'AURE-4', name:'Devon Izara', artist:null},
      {n:'AURE-5', name:'Wizzich Mozzer', artist:null},
      {n:'AURE-6', name:'General Maximilian Veers', artist:null},
      {n:'AURE-7', name:'Rune Haako', artist:null},
      {n:'AURE-8', name:'Tusken Raider Warrior', artist:null},
      {n:'AURE-9', name:'Baylan Skoll', artist:null},
      {n:'AURE-10', name:'Captain Kaido', artist:null},
      {n:'AURE-11', name:'Freck', artist:null},
      {n:'AURE-12', name:'Clone Captain Rex', artist:null},
      {n:'AURE-13', name:'Sy Snootles', artist:null},
      {n:'AURE-14', name:'Chewbacca', artist:null},
      {n:'AURE-15', name:'Rabé', artist:null},
      {n:'AURE-16', name:'Hamato Xiono', artist:null},
      {n:'AURE-17', name:'Ahsoka Tano', artist:null},
      {n:'AURE-18', name:'Davo Sculdun', artist:null},
      {n:'AURE-19', name:'At Attin frogdog', artist:null},
      {n:'AURE-20', name:'Icarus', artist:null},
      {n:'AURE-21', name:'Ezra Bridger', artist:null},
      {n:'AURE-22', name:'General Hux', artist:null},
      {n:'AURE-23', name:'Ben Quadinaros', artist:null},
      {n:'AURE-24', name:'Bo-Katan Kryze', artist:null},
      {n:'AURE-25', name:'Looti Vario', artist:null},
      {n:'AURE-26', name:'Sergeant Heert', artist:null},
      {n:'AURE-27', name:'Mace Windu', artist:null},
      {n:'AURE-28', name:'Nooma', artist:null},
      {n:'AURE-29', name:'General Grievous', artist:null},
      {n:'AURE-30', name:'Maz Kanata', artist:null},
      {n:'AURE-31', name:'Rey', artist:null},
      {n:'AURE-32', name:'Grogu', artist:null},
      {n:'AURE-33', name:'Grand Admiral Thrawn', artist:null},
      {n:'AURE-34', name:'Runai Sculdun', artist:null},
      {n:'AURE-35', name:'Hutt Sister', artist:null},
      {n:'AURE-36', name:'Ralakili', artist:null},
      {n:'AURE-37', name:'Mace Windu', artist:null},
      {n:'AURE-38', name:'Poe Dameron', artist:null},
      {n:'AURE-39', name:'Moff Gideon', artist:null},
      {n:'AURE-40', name:'Hera Syndulla', artist:null},
      {n:'AURE-41', name:'Senator Oran', artist:null},
      {n:'AURE-42', name:'The Armorer', artist:null},
      {n:'AURE-43', name:'Qi\'ra', artist:null},
      {n:'AURE-44', name:'Yoda', artist:null},
      {n:'AURE-45', name:'BB-8', artist:null},
      {n:'AURE-46', name:'D-O', artist:null},
      {n:'AURE-47', name:'The Mandalorian', artist:null},
      {n:'AURE-48', name:'Sabine Wren', artist:null},
      {n:'AURE-49', name:'Supervisor Lonni Jung', artist:null},
      {n:'AURE-50', name:'Vult Skerris', artist:null},
      {n:'AURE-51', name:'Dryden Vos', artist:null},
      {n:'AURE-52', name:'Anakin Skywalker', artist:null},
      {n:'AURE-53', name:'Finn', artist:null},
      {n:'AURE-54', name:'Colonel Aftab Ackbar', artist:null},
      {n:'AURE-55', name:'Zeb Orrelios', artist:null},
      {n:'AURE-56', name:'Shin Hati', artist:null},
      {n:'AURE-57', name:'Kylo Ren', artist:null},
      {n:'AURE-58', name:'Kanan Jarrus', artist:null},
      {n:'AURE-59', name:'Sidon Ithano', artist:null},
      {n:'AURE-60', name:'Klatooinian Crime Boss', artist:null},
      {n:'AURE-61', name:'Eedy Karn', artist:null},
      {n:'AURE-62', name:'Babu Frik', artist:null},
      {n:'AURE-63', name:'Cobb Vanth', artist:null},
      {n:'AURE-64', name:'Morgan Elsbeth', artist:null},
      {n:'AURE-65', name:'Ghorman Spider', artist:null},
      {n:'AURE-66', name:'Emperor Palpatine', artist:null},
      {n:'AURE-67', name:'Sergeant Gharial', artist:null},
      {n:'AURE-68', name:'Colonel Ward', artist:null},
      {n:'AURE-69', name:'Bobbajo', artist:null},
      {n:'AURE-70', name:'Haja Estree', artist:null},
      {n:'AURE-71', name:'Syril Karn', artist:null},
      {n:'AURE-72', name:'Commissioner Helgait', artist:null},
      {n:'AURE-73', name:'Erskin Semaj', artist:null},
      {n:'AURE-74', name:'Jyn Erso', artist:null},
      {n:'AURE-75', name:'Hype Fazon', artist:null},
      {n:'AURE-76', name:'Rook Kast', artist:null},
      {n:'AURE-77', name:'Scorn', artist:null},
      {n:'AURE-78', name:'Bix Caleen', artist:null},
      {n:'AURE-79', name:'Kuiil', artist:null},
      {n:'AURE-80', name:'Captain Enoch', artist:null},
      {n:'AURE-81', name:'Stekan Sculdun', artist:null},
      {n:'AURE-82', name:'Chirrut Îmwe', artist:null},
      {n:'AURE-83', name:'Han Solo', artist:null},
      {n:'AURE-84', name:'Imperial Inquisitor', artist:null},
      {n:'AURE-85', name:'Lieutenant Connix', artist:null},
      {n:'AURE-86', name:'Rose Tico', artist:null},
      {n:'AURE-87', name:'The Duchess of Plazir', artist:null},
      {n:'AURE-88', name:'Great Mother Lakesis', artist:null},
      {n:'AURE-89', name:'Drash', artist:null},
      {n:'AURE-90', name:'Jan Dodonna', artist:null},
      {n:'AURE-91', name:'Luke Skywalker', artist:null},
      {n:'AURE-92', name:'Niro', artist:null},
      {n:'AURE-93', name:'Captain Phasma', artist:null},
      {n:'AURE-94', name:'Jedi Master Sol', artist:null},
      {n:'AURE-95', name:'Omera', artist:null},
      {n:'AURE-96', name:'Vel Sartha', artist:null},
      {n:'AURE-97', name:'Kleya Marki', artist:null},
      {n:'AURE-98', name:'Huyang', artist:null},
      {n:'AURE-99', name:'Moff Tarkin', artist:null},
      {n:'AURE-100', name:'Bardi', artist:null},
      {n:'AURE-101', name:'Asajj Ventress', artist:null},
      {n:'AURE-102', name:'Supreme Leader Snoke', artist:null},
      {n:'AURE-103', name:'The Stranger', artist:null},
      {n:'AURE-104', name:'Captain Gilad Pellaeon', artist:null},
      {n:'AURE-105', name:'Cassian Andor', artist:null},
      {n:'AURE-106', name:'Pix the Tooka', artist:null},
      {n:'AURE-107', name:'Jace Rucklin', artist:null},
      {n:'AURE-108', name:'Ponda Baba', artist:null},
      {n:'AURE-109', name:'Raxshir', artist:null},
      {n:'AURE-110', name:'Noti', artist:null},
      {n:'AURE-111', name:'Jedi Master Indara', artist:null},
      {n:'AURE-112', name:'Hutt Brother', artist:null},
      {n:'AURE-113', name:'Mon Mothma', artist:null},
      {n:'AURE-114', name:'Leida Mothma', artist:null},
      {n:'AURE-115', name:'Dedra Meero', artist:null},
      {n:'AURE-116', name:'Owen Lars', artist:null},
      {n:'AURE-117', name:'Yaddle', artist:null},
      {n:'AURE-118', name:'Lovey', artist:null},
      {n:'AURE-119', name:'Massiff', artist:null},
      {n:'AURE-120', name:'Elia Kane', artist:null},
      {n:'AURE-121', name:'K-2SO', artist:null},
      {n:'AURE-122', name:'General Draven', artist:null},
      {n:'AURE-123', name:'Jod Na Nawood', artist:null},
      {n:'AURE-124', name:'Count Dooku', artist:null},
      {n:'AURE-125', name:'Bossk', artist:null},
      {n:'AURE-126', name:'Dobbu Scay', artist:null},
      {n:'AURE-127', name:'Imperial Remnant Snowtrooper', artist:null},
      {n:'AURE-128', name:'Ranzar "Ran" Malk', artist:null},
      {n:'AURE-129', name:'Luthen Rael', artist:null},
      {n:'AURE-130', name:'Bail Organa', artist:null},
      {n:'AURE-131', name:'Neel', artist:null},
      {n:'AURE-132', name:'Padmé Amidala', artist:null},
      {n:'AURE-133', name:'Zorii Bliss', artist:null},
      {n:'AURE-134', name:'Admiral Ackbar', artist:null},
      {n:'AURE-135', name:'Embo', artist:null},
      {n:'AURE-136', name:'Jawa', artist:null},
      {n:'AURE-137', name:'Saw Gerrera', artist:null},
      {n:'AURE-138', name:'Cinta Kaz', artist:null},
      {n:'AURE-139', name:'SM-33', artist:null},
      {n:'AURE-140', name:'Lyco Strata', artist:null},
      {n:'AURE-141', name:'Master Eeko-Dio Daki', artist:null},
      {n:'AURE-142', name:'Tallie Lintra', artist:null},
      {n:'AURE-143', name:'8D8', artist:null},
      {n:'AURE-144', name:'Greef Karga', artist:null},
      {n:'AURE-145', name:'Jabba the Hutt', artist:null},
      {n:'AURE-146', name:'Maul', artist:null},
      {n:'AURE-147', name:'Beela', artist:null},
      {n:'AURE-148', name:'Taun We', artist:null},
      {n:'AURE-149', name:'BDX Droid', artist:null},
      {n:'AURE-150', name:'Captain Peavey', artist:null},
      {n:'AURE-151', name:'Jedi Padawan Jecki Lon', artist:null},
      {n:'AURE-152', name:'Dreena', artist:null},
      {n:'AURE-153', name:'Supervisor Lagret', artist:null},
      {n:'AURE-154', name:'Beef', artist:null},
      {n:'AURE-155', name:'Luminara Unduli', artist:null},
      {n:'AURE-156', name:'Gatori', artist:null},
      {n:'AURE-157', name:'Captain Canady', artist:null},
      {n:'AURE-158', name:'Omega', artist:null},
      {n:'AURE-159', name:'Samm', artist:null},
      {n:'AURE-160', name:'Krrsantan', artist:null},
      {n:'AURE-161', name:'Spybot', artist:null},
      {n:'AURE-162', name:'Barriss Offee', artist:null},
      {n:'AURE-163', name:'B-1 Mercenary Droid', artist:null},
      {n:'AURE-164', name:'Jar Jar Binks', artist:null},
      {n:'AURE-165', name:'Boba Fett', artist:null},
      {n:'AURE-166', name:'Enza Rylanz', artist:null},
      {n:'AURE-167', name:'Clem Andor', artist:null},
      {n:'AURE-168', name:'Bubbles', artist:null},
      {n:'AURE-169', name:'C-3PO', artist:null},
      {n:'AURE-170', name:'Aayla Secura', artist:null},
      {n:'AURE-171', name:'Darth Maul', artist:null},
      {n:'AURE-172', name:'Cad Bane', artist:null},
      {n:'AURE-173', name:'Perrin Fertha', artist:null},
      {n:'AURE-174', name:'B2EMO', artist:null},
      {n:'AURE-175', name:'L3-37', artist:null},
      {n:'AURE-176', name:'Darth Vader', artist:null},
      {n:'AURE-177', name:'Plo Koon', artist:null},
      {n:'AURE-178', name:'Qui-Gon Jinn', artist:null},
      {n:'AURE-179', name:'Fennec Shand', artist:null},
      {n:'AURE-180', name:'Carro Rylanz', artist:null},
      {n:'AURE-181', name:'Brander Lawson', artist:null},
      {n:'AURE-182', name:'Hugo Durant', artist:null},
      {n:'AURE-183', name:'Leia Organa', artist:null},
      {n:'AURE-184', name:'Even Piell', artist:null},
      {n:'AURE-185', name:'Captain Typho', artist:null},
      {n:'AURE-186', name:'B-2 Mercenary Droid', artist:null},
      {n:'AURE-187', name:'Oathkeeper', artist:null},
      {n:'AURE-188', name:'Keibu', artist:null},
      {n:'AURE-189', name:'Gerdis', artist:null},
      {n:'AURE-190', name:'Lando Calrissian', artist:null},
      {n:'AURE-191', name:'Eleventh Brother', artist:null},
      {n:'AURE-192', name:'Vane', artist:null},
      {n:'AURE-193', name:'Mrs. Ikk', artist:null},
      {n:'AURE-194', name:'Dr. Royce Hemlock', artist:null},
      {n:'AURE-195', name:'Lord Janu', artist:null},
      {n:'AURE-196', name:'Droopy McCool', artist:null},
      {n:'AURE-197', name:'R2-D2', artist:null},
      {n:'AURE-198', name:'Oppo Rancisis', artist:null},
      {n:'AURE-199', name:'The Grand Inquisitor', artist:null},
      {n:'AURE-200', name:'Rotta the Hutt', artist:null},
    ],
  },
  {
    id: 'andor-season-2-characters', type: 'insert', title: 'ANDOR SEASON 2 CHARACTERS — 17 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'A2-B2', name:'B2EMO', artist:null},
      {n:'A2-BIX', name:'Bix Caleen', artist:null},
      {n:'A2-BRA', name:'Brasso', artist:null},
      {n:'A2-CASS', name:'Cassian Andor', artist:null},
      {n:'A2-DEDRA', name:'Dedra Meero', artist:null},
      {n:'A2-DIRE', name:'Director Krennic', artist:null},
      {n:'A2-GORST', name:'Dr. Gorst', artist:null},
      {n:'A2-KARN', name:'Syril Karn', artist:null},
      {n:'A2-KAZ', name:'Cinta Kaz', artist:null},
      {n:'A2-MARK', name:'Kleya Marki', artist:null},
      {n:'A2-PAAK', name:'Wilmon Paak', artist:null},
      {n:'A2-PART', name:'Major Partagaz', artist:null},
      {n:'A2-RAEL', name:'Luthen Rael', artist:null},
      {n:'A2-SAW', name:'Saw Gerrera', artist:null},
      {n:'A2-TAY', name:'Tay Kolma', artist:null},
      {n:'AS-K2', name:'K-2SO', artist:null},
      {n:'AS-MON', name:'Mon Mothma', artist:null},
    ],
  },
  {
    id: 'andor-season-2-moments', type: 'insert', title: 'ANDOR SEASON 2 MOMENTS — 12 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'AM-1', name:'An Uncomfortable Dinner', artist:null},
      {n:'AM-2', name:'Mon Mothma Dances', artist:null},
      {n:'AM-3', name:'Cassian Andor Saves His Friends', artist:null},
      {n:'AM-4', name:'"We Should Have Killed Krennic"', artist:null},
      {n:'AM-5', name:'Bix Caleen Gets Revenge On Dr. Gorst', artist:null},
      {n:'AM-6', name:'"Who Are You?"', artist:null},
      {n:'AM-7', name:'Mon Mothma Fights The Empire', artist:null},
      {n:'AM-8', name:'"I Have Friends Everywhere"', artist:null},
      {n:'AM-9', name:'Dedra Meero Finally Meets Axis', artist:null},
      {n:'AM-10', name:'Dedra Meero\'s Interrogation', artist:null},
      {n:'AM-11', name:'K-2SO Provides Backup', artist:null},
      {n:'AM-12', name:'Consequences', artist:null},
    ],
  },
  {
    id: 'visions-season-3-characters', type: 'insert', title: 'VISIONS SEASON 3 CHARACTERS — 14 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'V3-AS', name:'Anée-San', artist:null},
      {n:'V3-CHIT', name:'Chita', artist:null},
      {n:'V3-CRA', name:'Crane', artist:null},
      {n:'V3-F', name:'F', artist:null},
      {n:'V3-FOX', name:'Fox-Ear', artist:null},
      {n:'V3-GRA', name:'Grand Master', artist:null},
      {n:'V3-KAR', name:'Lah Kara', artist:null},
      {n:'V3-NAKIM', name:'Nakime', artist:null},
      {n:'V3-RON', name:'Ronin', artist:null},
      {n:'V3-SHA', name:'Shad-Rah', artist:null},
      {n:'V3-TETO', name:'Teto', artist:null},
      {n:'V3-WOO', name:'Woopas', artist:null},
      {n:'V3-YUKO', name:'Yuko', artist:null},
      {n:'V3-ZIM', name:'Lah Zhima', artist:null},
    ],
  },
  {
    id: 'visions-season-3-moments', type: 'insert', title: 'VISIONS SEASON 3 MOMENTS — 9 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'V3-1', name:'The Grand Master vs Ronin', artist:null},
      {n:'V3-2', name:'Crane Saves Woopas', artist:null},
      {n:'V3-3', name:'Kara Fights Off the Hunters', artist:null},
      {n:'V3-4', name:'Sevn And IV-A4 On The Run', artist:null},
      {n:'V3-5', name:'Leaving Mos Eisley', artist:null},
      {n:'V3-6', name:'F vs Shad-Rah', artist:null},
      {n:'V3-7', name:'Gleenu Reveals Her Hidden Past', artist:null},
      {n:'V3-8', name:'The Temptation Of The Dark Side', artist:null},
      {n:'V3-9', name:'Black', artist:null},
    ],
  },
  {
    id: 'mando-and-grogu-characters', type: 'insert', title: 'THE MANDALORIAN AND GROGU CHARACTERS — 26 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'MAGR-AT', name:'Imperial Remnant AT-AT Driver', artist:null},
      {n:'MAGR-BAI', name:'Bai', artist:null},
      {n:'MAGR-CLAN', name:'Clang', artist:null},
      {n:'MAGR-DEER', name:'BDX Droid', artist:null},
      {n:'MAGR-EMB', name:'Embo', artist:null},
      {n:'MAGR-GAT', name:'Gatori', artist:null},
      {n:'MAGR-GHH', name:'Ghhhk', artist:null},
      {n:'MAGR-GRO', name:'Grogu', artist:null},
      {n:'MAGR-HOU', name:'Houjix', artist:null},
      {n:'MAGR-JAN', name:'Lord Janu', artist:null},
      {n:'MAGR-KEET', name:'Keeto', artist:null},
      {n:'MAGR-KINT', name:'Kintan Strider', artist:null},
      {n:'MAGR-KLO', name:'K\'lor\'slug', artist:null},
      {n:'MAGR-MAN', name:'The Mandalorian', artist:null},
      {n:'MAGR-MANT', name:'Mantellian Savrip', artist:null},
      {n:'MAGR-MINC', name:'Minch', artist:null},
      {n:'MAGR-MOL', name:'Molatar', artist:null},
      {n:'MAGR-MON', name:'Monnok', artist:null},
      {n:'MAGR-NGO', name:'Ng\'ok', artist:null},
      {n:'MAGR-R5', name:'R5-D4', artist:null},
      {n:'MAGR-ROT', name:'Rotta the Hutt', artist:null},
      {n:'MAGR-SNOW', name:'Imperial Remnant Snowtrooper', artist:null},
      {n:'MAGR-ST', name:'Stormtrooper', artist:null},
      {n:'MAGR-TWIN', name:'Hutt Twins', artist:null},
      {n:'MAGR-WARD', name:'Colonel Ward', artist:null},
      {n:'MAGR-ZEB', name:'Zeb Orrelios', artist:null},
    ],
  },
  {
    id: 'mando-and-grogu-moments', type: 'insert', title: 'THE MANDALORIAN AND GROGU MOMENTS — 17 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'MAGR-1', name:'Refitting The Mandalorian\'s Ship', artist:null},
      {n:'MAGR-2', name:'Miniature Mechanics', artist:null},
      {n:'MAGR-3', name:'Tracking Grogu', artist:null},
      {n:'MAGR-4', name:'A Friendly Favor', artist:null},
      {n:'MAGR-5', name:'Defending The Imperial Base', artist:null},
      {n:'MAGR-6', name:'An Unlikely Means Of Escape', artist:null},
      {n:'MAGR-7', name:'On The Hunt', artist:null},
      {n:'MAGR-8', name:'Stake Out', artist:null},
      {n:'MAGR-9', name:'Inhospitable Conditions', artist:null},
      {n:'MAGR-10', name:'Back In The Razor Crest', artist:null},
      {n:'MAGR-11', name:'Tiny Ride, Big Friends!', artist:null},
      {n:'MAGR-12', name:'The Pit Fight', artist:null},
      {n:'MAGR-13', name:'Grogu\'s Distraction', artist:null},
      {n:'MAGR-14', name:'Inside The AT-AT', artist:null},
      {n:'MAGR-15', name:'Cooking Up Information', artist:null},
      {n:'MAGR-16', name:'The Twins\' Scheme', artist:null},
      {n:'MAGR-17', name:'A Place Of Peace', artist:null},
    ],
  },
  {
    id: 'oblivion', type: 'insert', title: 'OBLIVION — 16 CARDS',
    parallels: [{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'wave-refractor',name:'Wave Refractor',print_run:5,color:'#5b9dff'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'O-1', name:'Cassian Andor', artist:null},
      {n:'O-2', name:'K-2SO', artist:null},
      {n:'O-3', name:'The Mandalorian', artist:null},
      {n:'O-4', name:'Moff Gideon', artist:null},
      {n:'O-5', name:'Stormtrooper', artist:null},
      {n:'O-6', name:'Paz Vizsla', artist:null},
      {n:'O-7', name:'Chopper', artist:null},
      {n:'O-8', name:'Tie Fighter Pilot', artist:null},
      {n:'O-9', name:'Jango Fett', artist:null},
      {n:'O-10', name:'Luke Skywalker', artist:null},
      {n:'O-11', name:'Finn', artist:null},
      {n:'O-12', name:'Captain Phasma', artist:null},
      {n:'O-13', name:'Death Trooper', artist:null},
      {n:'O-14', name:'Boba Fett', artist:null},
      {n:'O-15', name:'R2-D2', artist:null},
      {n:'O-16', name:'BB-8', artist:null},
    ],
  },
  {
    id: 'stormtrooper-command', type: 'insert', title: 'STORMTROOPER COMMAND — 20 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'SC-1', name:'Stormtrooper Helmet 1', artist:null},
      {n:'SC-2', name:'Stormtrooper Helmet 2', artist:null},
      {n:'SC-3', name:'Stormtrooper Helmet 3', artist:null},
      {n:'SC-4', name:'Stormtrooper Helmet 4', artist:null},
      {n:'SC-5', name:'Stormtrooper Helmet 5', artist:null},
      {n:'SC-6', name:'Stormtrooper Helmet 6', artist:null},
      {n:'SC-7', name:'Stormtrooper Helmet 7', artist:null},
      {n:'SC-8', name:'Stormtrooper Helmet 8', artist:null},
      {n:'SC-9', name:'Stormtrooper Helmet 9', artist:null},
      {n:'SC-10', name:'Stormtrooper Helmet 10', artist:null},
      {n:'SC-11', name:'Stormtrooper Helmet 11', artist:null},
      {n:'SC-12', name:'Stormtrooper Helmet 12', artist:null},
      {n:'SC-13', name:'Stormtrooper Helmet 13', artist:null},
      {n:'SC-14', name:'Stormtrooper Helmet 14', artist:null},
      {n:'SC-15', name:'Stormtrooper Helmet 15', artist:null},
      {n:'SC-16', name:'Stormtrooper Helmet 16', artist:null},
      {n:'SC-17', name:'Stormtrooper Helmet 17', artist:null},
      {n:'SC-18', name:'Stormtrooper Helmet 18', artist:null},
      {n:'SC-19', name:'Stormtrooper Helmet 19', artist:null},
      {n:'SC-20', name:'Stormtrooper Helmet 20', artist:null},
    ],
  },
  {
    id: 'galaxys-cutest', type: 'insert', title: 'GALAXY\'S CUTEST — 15 CARDS',
    parallels: [{id:'kashyyyk-refractor',name:'Kashyyyk Refractor',print_run:99,color:'#5fd35f'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'QT-1', name:'Anzellan', artist:null},
      {n:'QT-2', name:'Trash Crab', artist:null},
      {n:'QT-3', name:'Dokma', artist:null},
      {n:'QT-4', name:'Ewok', artist:null},
      {n:'QT-5', name:'Grogu', artist:null},
      {n:'QT-6', name:'Jawa', artist:null},
      {n:'QT-7', name:'Lava Meerkat', artist:null},
      {n:'QT-8', name:'Loth-Cat', artist:null},
      {n:'QT-9', name:'Noti', artist:null},
      {n:'QT-10', name:'Myykian', artist:null},
      {n:'QT-11', name:'Puffer Pig', artist:null},
      {n:'QT-12', name:'Porg', artist:null},
      {n:'QT-13', name:'Oki-Poki', artist:null},
      {n:'QT-14', name:'Tooka Cat', artist:null},
      {n:'QT-15', name:'Wookiee', artist:null},
    ],
  },
  {
    id: 'galactic-maximalists', type: 'insert', title: 'GALACTIC MAXIMALISTS — 10 CARDS',
    parallels: [{id:'mini-diamond-refractor',name:'Mini-Diamond Refractor',print_run:50,color:'#f3d985'},{id:'mojo-refractor',name:'Mojo Refractor',print_run:25,color:'#ff9d52'},{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'wave-refractor',name:'Wave Refractor',print_run:5,color:'#5b9dff'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'GMAX-C3', name:'C-3PO', artist:null},
      {n:'GMAX-CHEWIE', name:'Chewbacca', artist:null},
      {n:'GMAX-FETT', name:'Boba Fett', artist:null},
      {n:'GMAX-JABBA', name:'Jabba the Hutt', artist:null},
      {n:'GMAX-OBI', name:'Obi-Wan Kenobi', artist:null},
      {n:'GMAX-QUEEN', name:'Queen Amidala', artist:null},
      {n:'GMAX-REBO', name:'Max Rebo', artist:null},
      {n:'GMAX-SKY', name:'Luke Skywalker', artist:null},
      {n:'GMAX-VADER', name:'Darth Vader', artist:null},
      {n:'GMAX-YODA', name:'Yoda', artist:null},
    ],
  },
  {
    id: 'factions', type: 'insert', title: 'FACTIONS — 10 CARDS',
    parallels: [{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'wave-refractor',name:'Wave Refractor',print_run:5,color:'#5b9dff'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'SQUAD-1', name:'Bounty Hunters', artist:null},
      {n:'SQUAD-2', name:'First Order', artist:null},
      {n:'SQUAD-3', name:'Galactic Empire', artist:null},
      {n:'SQUAD-4', name:'Hutt Clan', artist:null},
      {n:'SQUAD-5', name:'Jedi Order', artist:null},
      {n:'SQUAD-6', name:'Phoenix Squadron', artist:null},
      {n:'SQUAD-7', name:'Rebel Alliance', artist:null},
      {n:'SQUAD-8', name:'Resistance', artist:null},
      {n:'SQUAD-9', name:'Sith', artist:null},
      {n:'SQUAD-10', name:'Inquisitorius', artist:null},
    ],
  },
  {
    id: 'cosmic-crystals', type: 'insert', title: 'COSMIC CRYSTALS — 50 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'COS-1', name:'Leia Organa', artist:null},
      {n:'COS-2', name:'Bo-Katan Kryze', artist:null},
      {n:'COS-3', name:'Fennec Shand', artist:null},
      {n:'COS-4', name:'Rey', artist:null},
      {n:'COS-5', name:'Poe Dameron', artist:null},
      {n:'COS-6', name:'Darth Vader', artist:null},
      {n:'COS-7', name:'Count Dooku', artist:null},
      {n:'COS-8', name:'Mace Windu', artist:null},
      {n:'COS-9', name:'Obi-Wan Kenobi', artist:null},
      {n:'COS-10', name:'Luke Skywalker', artist:null},
      {n:'COS-11', name:'Chewbacca', artist:null},
      {n:'COS-12', name:'Han Solo', artist:null},
      {n:'COS-13', name:'Ahsoka Tano', artist:null},
      {n:'COS-14', name:'Sabine Wren', artist:null},
      {n:'COS-15', name:'Shin Hati', artist:null},
      {n:'COS-16', name:'Lando Calrissian', artist:null},
      {n:'COS-17', name:'Maz Kanata', artist:null},
      {n:'COS-18', name:'BB-8', artist:null},
      {n:'COS-19', name:'C-3PO', artist:null},
      {n:'COS-20', name:'Grogu', artist:null},
      {n:'COS-21', name:'The Mandalorian', artist:null},
      {n:'COS-22', name:'Kylo Ren', artist:null},
      {n:'COS-23', name:'Boba Fett', artist:null},
      {n:'COS-24', name:'Padmé Amidala', artist:null},
      {n:'COS-25', name:'Hera Syndulla', artist:null},
      {n:'COS-26', name:'Captain Phasma', artist:null},
      {n:'COS-27', name:'Cassian Andor', artist:null},
      {n:'COS-28', name:'Mon Mothma', artist:null},
      {n:'COS-29', name:'Jod Na Nawood', artist:null},
      {n:'COS-30', name:'Neel', artist:null},
      {n:'COS-31', name:'Finn', artist:null},
      {n:'COS-32', name:'Chopper', artist:null},
      {n:'COS-33', name:'R2-D2', artist:null},
      {n:'COS-34', name:'Kit Fisto', artist:null},
      {n:'COS-35', name:'Anakin Skywalker', artist:null},
      {n:'COS-36', name:'General Grievous', artist:null},
      {n:'COS-37', name:'Shaak Ti', artist:null},
      {n:'COS-38', name:'Grand Admiral Thrawn', artist:null},
      {n:'COS-39', name:'Porg', artist:null},
      {n:'COS-40', name:'Jyn Erso', artist:null},
      {n:'COS-41', name:'Darth Sidious', artist:null},
      {n:'COS-42', name:'Yoda', artist:null},
      {n:'COS-43', name:'Qi\'ra', artist:null},
      {n:'COS-44', name:'The Grand Inquisitor', artist:null},
      {n:'COS-45', name:'Vice Admiral Holdo', artist:null},
      {n:'COS-46', name:'Qui-Gon Jinn', artist:null},
      {n:'COS-47', name:'Max Rebo', artist:null},
      {n:'COS-48', name:'Clone Trooper', artist:null},
      {n:'COS-49', name:'Kaydel Ko Connix', artist:null},
      {n:'COS-50', name:'Sabé', artist:null},
    ],
  },
  {
    id: 'bonus-stage', type: 'insert', title: 'BONUS STAGE — 12 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'BO-BEN', name:'Obi-Wan Kenobi', artist:null},
      {n:'BO-BOSS', name:'Bossk', artist:null},
      {n:'BO-DV', name:'Darth Vader', artist:null},
      {n:'BO-FET', name:'Boba Fett', artist:null},
      {n:'BO-GRE', name:'Greedo', artist:null},
      {n:'BO-JAW', name:'Jawa', artist:null},
      {n:'BO-LAC', name:'Lando Calrissian', artist:null},
      {n:'BO-LO', name:'Leia Organa', artist:null},
      {n:'BO-LUKE', name:'Luke Skywalker', artist:null},
      {n:'BO-R2', name:'R2-D2', artist:null},
      {n:'BO-ST', name:'Scout Trooper', artist:null},
      {n:'BO-YO', name:'Yoda', artist:null},
    ],
  },
  {
    id: 'kyber-light', type: 'insert', title: 'KYBER LIGHT — 10 CARDS',
    parallels: [{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'wave-refractor',name:'Wave Refractor',print_run:5,color:'#5b9dff'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'KL-21', name:'Bo-Katan Kryze', artist:null},
      {n:'KL-22', name:'Grand Admiral Thrawn', artist:null},
      {n:'KL-23', name:'Hera Syndulla', artist:null},
      {n:'KL-24', name:'Kit Fisto', artist:null},
      {n:'KL-25', name:'Mace Windu', artist:null},
      {n:'KL-26', name:'Neel', artist:null},
      {n:'KL-27', name:'Sabine Wren', artist:null},
      {n:'KL-28', name:'Savage Opress', artist:null},
      {n:'KL-29', name:'Shaak Ti', artist:null},
      {n:'KL-30', name:'Zeb Orrelios', artist:null},
    ],
  },
  {
    id: 'eras', type: 'insert', title: 'ERAS — 9 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'E-1', name:'The First', artist:null},
      {n:'E-2', name:'The Second', artist:null},
      {n:'E-3', name:'The Third', artist:null},
      {n:'E-4', name:'The Fourth', artist:null},
      {n:'E-5', name:'The Fifth', artist:null},
      {n:'E-6', name:'The Sixth', artist:null},
      {n:'E-7', name:'The Seventh', artist:null},
      {n:'E-8', name:'The Eighth', artist:null},
      {n:'E-9', name:'The Ninth', artist:null},
    ],
  },
  {
    id: 'reflections', type: 'insert', title: 'REFLECTIONS — 5 CARDS',
    parallels: [{id:'kaleidoscope-refractor',name:'Kaleidoscope Refractor',print_run:25,color:'#e7c3e2'},{id:'raywave-refractor',name:'RayWave Refractor',print_run:5,color:'#6cef4d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'R-16', name:'Captain Phasma', artist:null},
      {n:'R-17', name:'Clone Commander Cody', artist:null},
      {n:'R-18', name:'Imperial Red Guard', artist:null},
      {n:'R-19', name:'Luke Skywalker', artist:null},
      {n:'R-20', name:'Moff Gideon', artist:null},
    ],
  },
  {
    id: 'comicfractor', type: 'insert', title: 'COMICFRACTOR — 5 CARDS',
    parallels: [{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'x-fractor',name:'X-Fractor',print_run:10,color:'#84e04a'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'VC-16', name:'C-3PO', artist:null},
      {n:'VC-17', name:'Chewbacca', artist:null},
      {n:'VC-18', name:'Han Solo', artist:null},
      {n:'VC-19', name:'Jawa', artist:null},
      {n:'VC-20', name:'The Emperor', artist:null},
    ],
  },
  {
    id: 'printing-plate-book-card', type: 'insert', title: 'PRINTING PLATE BOOK CARDS — 200 CARDS',
    parallels: [],
    cards: [
      {n:'PLATE-1', name:'Obi-Wan Kenobi', artist:null},
      {n:'PLATE-2', name:'Lezine', artist:null},
      {n:'PLATE-3', name:'Chopper', artist:null},
      {n:'PLATE-4', name:'Devon Izara', artist:null},
      {n:'PLATE-5', name:'Wizzich Mozzer', artist:null},
      {n:'PLATE-6', name:'General Maximilian Veers', artist:null},
      {n:'PLATE-7', name:'Rune Haako', artist:null},
      {n:'PLATE-8', name:'Tusken Raider Warrior', artist:null},
      {n:'PLATE-9', name:'Baylan Skoll', artist:null},
      {n:'PLATE-10', name:'Captain Kaido', artist:null},
      {n:'PLATE-11', name:'Freck', artist:null},
      {n:'PLATE-12', name:'Clone Captain Rex', artist:null},
      {n:'PLATE-13', name:'Sy Snootles', artist:null},
      {n:'PLATE-14', name:'Chewbacca', artist:null},
      {n:'PLATE-15', name:'Rabé', artist:null},
      {n:'PLATE-16', name:'Hamato Xiono', artist:null},
      {n:'PLATE-17', name:'Ahsoka Tano', artist:null},
      {n:'PLATE-18', name:'Davo Sculdun', artist:null},
      {n:'PLATE-19', name:'At Attin frogdog', artist:null},
      {n:'PLATE-20', name:'Icarus', artist:null},
      {n:'PLATE-21', name:'Ezra Bridger', artist:null},
      {n:'PLATE-22', name:'General Hux', artist:null},
      {n:'PLATE-23', name:'Ben Quadinaros', artist:null},
      {n:'PLATE-24', name:'Bo-Katan Kryze', artist:null},
      {n:'PLATE-25', name:'Looti Vario', artist:null},
      {n:'PLATE-26', name:'Sergeant Heert', artist:null},
      {n:'PLATE-27', name:'Mace Windu', artist:null},
      {n:'PLATE-28', name:'Nooma', artist:null},
      {n:'PLATE-29', name:'General Grievous', artist:null},
      {n:'PLATE-30', name:'Maz Kanata', artist:null},
      {n:'PLATE-31', name:'Rey', artist:null},
      {n:'PLATE-32', name:'Grogu', artist:null},
      {n:'PLATE-33', name:'Grand Admiral Thrawn', artist:null},
      {n:'PLATE-34', name:'Runai Sculdun', artist:null},
      {n:'PLATE-35', name:'Hutt Sister', artist:null},
      {n:'PLATE-36', name:'Ralakili', artist:null},
      {n:'PLATE-37', name:'Mace Windu', artist:null},
      {n:'PLATE-38', name:'Poe Dameron', artist:null},
      {n:'PLATE-39', name:'Moff Gideon', artist:null},
      {n:'PLATE-40', name:'Hera Syndulla', artist:null},
      {n:'PLATE-41', name:'Senator Oran', artist:null},
      {n:'PLATE-42', name:'The Armorer', artist:null},
      {n:'PLATE-43', name:'Qi\'ra', artist:null},
      {n:'PLATE-44', name:'Yoda', artist:null},
      {n:'PLATE-45', name:'BB-8', artist:null},
      {n:'PLATE-46', name:'D-O', artist:null},
      {n:'PLATE-47', name:'The Mandalorian', artist:null},
      {n:'PLATE-48', name:'Sabine Wren', artist:null},
      {n:'PLATE-49', name:'Supervisor Lonni Jung', artist:null},
      {n:'PLATE-50', name:'Vult Skerris', artist:null},
      {n:'PLATE-51', name:'Dryden Vos', artist:null},
      {n:'PLATE-52', name:'Anakin Skywalker', artist:null},
      {n:'PLATE-53', name:'Finn', artist:null},
      {n:'PLATE-54', name:'Colonel Aftab Ackbar', artist:null},
      {n:'PLATE-55', name:'Zeb Orrelios', artist:null},
      {n:'PLATE-56', name:'Shin Hati', artist:null},
      {n:'PLATE-57', name:'Kylo Ren', artist:null},
      {n:'PLATE-58', name:'Kanan Jarrus', artist:null},
      {n:'PLATE-59', name:'Sidon Ithano', artist:null},
      {n:'PLATE-60', name:'Klatooinian Crime Boss', artist:null},
      {n:'PLATE-61', name:'Eedy Karn', artist:null},
      {n:'PLATE-62', name:'Babu Frik', artist:null},
      {n:'PLATE-63', name:'Cobb Vanth', artist:null},
      {n:'PLATE-64', name:'Morgan Elsbeth', artist:null},
      {n:'PLATE-65', name:'Ghorman Spider', artist:null},
      {n:'PLATE-66', name:'Emperor Palpatine', artist:null},
      {n:'PLATE-67', name:'Sergeant Gharial', artist:null},
      {n:'PLATE-68', name:'Colonel Ward', artist:null},
      {n:'PLATE-69', name:'Bobbajo', artist:null},
      {n:'PLATE-70', name:'Haja Estree', artist:null},
      {n:'PLATE-71', name:'Syril Karn', artist:null},
      {n:'PLATE-72', name:'Commissioner Helgait', artist:null},
      {n:'PLATE-73', name:'Erskin Semaj', artist:null},
      {n:'PLATE-74', name:'Jyn Erso', artist:null},
      {n:'PLATE-75', name:'Hype Fazon', artist:null},
      {n:'PLATE-76', name:'Rook Kast', artist:null},
      {n:'PLATE-77', name:'Scorn', artist:null},
      {n:'PLATE-78', name:'Bix Caleen', artist:null},
      {n:'PLATE-79', name:'Kuiil', artist:null},
      {n:'PLATE-80', name:'Captain Enoch', artist:null},
      {n:'PLATE-81', name:'Stekan Sculdun', artist:null},
      {n:'PLATE-82', name:'Chirrut Îmwe', artist:null},
      {n:'PLATE-83', name:'Han Solo', artist:null},
      {n:'PLATE-84', name:'Imperial Inquisitor', artist:null},
      {n:'PLATE-85', name:'Lieutenant Connix', artist:null},
      {n:'PLATE-86', name:'Rose Tico', artist:null},
      {n:'PLATE-87', name:'The Duchess of Plazir', artist:null},
      {n:'PLATE-88', name:'Great Mother Lakesis', artist:null},
      {n:'PLATE-89', name:'Drash', artist:null},
      {n:'PLATE-90', name:'Jan Dodonna', artist:null},
      {n:'PLATE-91', name:'Luke Skywalker', artist:null},
      {n:'PLATE-92', name:'Niro', artist:null},
      {n:'PLATE-93', name:'Captain Phasma', artist:null},
      {n:'PLATE-94', name:'Jedi Master Sol', artist:null},
      {n:'PLATE-95', name:'Omera', artist:null},
      {n:'PLATE-96', name:'Vel Sartha', artist:null},
      {n:'PLATE-97', name:'Kleya Marki', artist:null},
      {n:'PLATE-98', name:'Huyang', artist:null},
      {n:'PLATE-99', name:'Moff Tarkin', artist:null},
      {n:'PLATE-100', name:'Bardi', artist:null},
      {n:'PLATE-101', name:'Asajj Ventress', artist:null},
      {n:'PLATE-102', name:'Supreme Leader Snoke', artist:null},
      {n:'PLATE-103', name:'The Stranger', artist:null},
      {n:'PLATE-104', name:'Captain Gilad Pellaeon', artist:null},
      {n:'PLATE-105', name:'Cassian Andor', artist:null},
      {n:'PLATE-106', name:'Pix the Tooka', artist:null},
      {n:'PLATE-107', name:'Jace Rucklin', artist:null},
      {n:'PLATE-108', name:'Ponda Baba', artist:null},
      {n:'PLATE-109', name:'Raxshir', artist:null},
      {n:'PLATE-110', name:'Noti', artist:null},
      {n:'PLATE-111', name:'Jedi Master Indara', artist:null},
      {n:'PLATE-112', name:'Hutt Brother', artist:null},
      {n:'PLATE-113', name:'Mon Mothma', artist:null},
      {n:'PLATE-114', name:'Leida Mothma', artist:null},
      {n:'PLATE-115', name:'Dedra Meero', artist:null},
      {n:'PLATE-116', name:'Owen Lars', artist:null},
      {n:'PLATE-117', name:'Yaddle', artist:null},
      {n:'PLATE-118', name:'Lovey', artist:null},
      {n:'PLATE-119', name:'Massiff', artist:null},
      {n:'PLATE-120', name:'Elia Kane', artist:null},
      {n:'PLATE-121', name:'K-2SO', artist:null},
      {n:'PLATE-122', name:'General Draven', artist:null},
      {n:'PLATE-123', name:'Jod Na Nawood', artist:null},
      {n:'PLATE-124', name:'Count Dooku', artist:null},
      {n:'PLATE-125', name:'Bossk', artist:null},
      {n:'PLATE-126', name:'Dobbu Scay', artist:null},
      {n:'PLATE-127', name:'Imperial Remnant Snowtrooper', artist:null},
      {n:'PLATE-128', name:'Ranzar "Ran" Malk', artist:null},
      {n:'PLATE-129', name:'Luthen Rael', artist:null},
      {n:'PLATE-130', name:'Bail Organa', artist:null},
      {n:'PLATE-131', name:'Neel', artist:null},
      {n:'PLATE-132', name:'Padmé Amidala', artist:null},
      {n:'PLATE-133', name:'Zorii Bliss', artist:null},
      {n:'PLATE-134', name:'Admiral Ackbar', artist:null},
      {n:'PLATE-135', name:'Embo', artist:null},
      {n:'PLATE-136', name:'Jawa', artist:null},
      {n:'PLATE-137', name:'Saw Gerrera', artist:null},
      {n:'PLATE-138', name:'Cinta Kaz', artist:null},
      {n:'PLATE-139', name:'SM-33', artist:null},
      {n:'PLATE-140', name:'Lyco Strata', artist:null},
      {n:'PLATE-141', name:'Master Eeko-Dio Daki', artist:null},
      {n:'PLATE-142', name:'Tallie Lintra', artist:null},
      {n:'PLATE-143', name:'8D8', artist:null},
      {n:'PLATE-144', name:'Greef Karga', artist:null},
      {n:'PLATE-145', name:'Jabba the Hutt', artist:null},
      {n:'PLATE-146', name:'Maul', artist:null},
      {n:'PLATE-147', name:'Beela', artist:null},
      {n:'PLATE-148', name:'Taun We', artist:null},
      {n:'PLATE-149', name:'BDX Droid', artist:null},
      {n:'PLATE-150', name:'Captain Peavey', artist:null},
      {n:'PLATE-151', name:'Jedi Padawan Jecki Lon', artist:null},
      {n:'PLATE-152', name:'Dreena', artist:null},
      {n:'PLATE-153', name:'Supervisor Lagret', artist:null},
      {n:'PLATE-154', name:'Beef', artist:null},
      {n:'PLATE-155', name:'Luminara Unduli', artist:null},
      {n:'PLATE-156', name:'Gatori', artist:null},
      {n:'PLATE-157', name:'Captain Canady', artist:null},
      {n:'PLATE-158', name:'Omega', artist:null},
      {n:'PLATE-159', name:'Samm', artist:null},
      {n:'PLATE-160', name:'Krrsantan', artist:null},
      {n:'PLATE-161', name:'Spybot', artist:null},
      {n:'PLATE-162', name:'Barriss Offee', artist:null},
      {n:'PLATE-163', name:'B-1 Mercenary Droid', artist:null},
      {n:'PLATE-164', name:'Jar Jar Binks', artist:null},
      {n:'PLATE-165', name:'Boba Fett', artist:null},
      {n:'PLATE-166', name:'Enza Rylanz', artist:null},
      {n:'PLATE-167', name:'Clem Andor', artist:null},
      {n:'PLATE-168', name:'Bubbles', artist:null},
      {n:'PLATE-169', name:'C-3PO', artist:null},
      {n:'PLATE-170', name:'Aayla Secura', artist:null},
      {n:'PLATE-171', name:'Darth Maul', artist:null},
      {n:'PLATE-172', name:'Cad Bane', artist:null},
      {n:'PLATE-173', name:'Perrin Fertha', artist:null},
      {n:'PLATE-174', name:'B2EMO', artist:null},
      {n:'PLATE-175', name:'L3-37', artist:null},
      {n:'PLATE-176', name:'Darth Vader', artist:null},
      {n:'PLATE-177', name:'Plo Koon', artist:null},
      {n:'PLATE-178', name:'Qui-Gon Jinn', artist:null},
      {n:'PLATE-179', name:'Fennec Shand', artist:null},
      {n:'PLATE-180', name:'Carro Rylanz', artist:null},
      {n:'PLATE-181', name:'Brander Lawson', artist:null},
      {n:'PLATE-182', name:'Hugo Durant', artist:null},
      {n:'PLATE-183', name:'Leia Organa', artist:null},
      {n:'PLATE-184', name:'Even Piell', artist:null},
      {n:'PLATE-185', name:'Captain Typho', artist:null},
      {n:'PLATE-186', name:'B-2 Mercenary Droid', artist:null},
      {n:'PLATE-187', name:'Oathkeeper', artist:null},
      {n:'PLATE-188', name:'Keibu', artist:null},
      {n:'PLATE-189', name:'Gerdis', artist:null},
      {n:'PLATE-190', name:'Lando Calrissian', artist:null},
      {n:'PLATE-191', name:'Eleventh Brother', artist:null},
      {n:'PLATE-192', name:'Vane', artist:null},
      {n:'PLATE-193', name:'Mrs. Ikk', artist:null},
      {n:'PALTE-194', name:'Dr. Royce Hemlock', artist:null},
      {n:'PLATE-195', name:'Lord Janu', artist:null},
      {n:'PLATE-196', name:'Droopy McCool', artist:null},
      {n:'PLATE-197', name:'R2-D2', artist:null},
      {n:'PLATE-198', name:'Oppo Rancisis', artist:null},
      {n:'PLATE-199', name:'The Grand Inquisitor', artist:null},
      {n:'PLATE-200', name:'Rotta the Hutt', artist:null},
    ],
  },
  {
    id: 'autograph-cards', type: 'auto', title: 'AUTOGRAPH CARDS — 181 CARDS',
    parallels: [{id:'green-refractor',name:'Green Refractor',print_run:99,color:'#5fd35f'},{id:'star-wars-logofractor',name:'Star Wars LogoFractor',print_run:77,color:'#ffe27a'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'A-AB', name:'Ahmed Best', artist:'Jar Jar Binks'},
      {n:'A-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'A-AS', name:'Andy Serkis', artist:'Supreme Leader Snoke'},
      {n:'A-AT', name:'Alan Tudyk', artist:'K-2SO'},
      {n:'A-BB', name:'Blair Bess', artist:'Even Piell'},
      {n:'A-BD', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'A-BLUM', name:'Steve Blum', artist:'Icarus'},
      {n:'A-BN', name:'Benjamin Norris', artist:'Bardi'},
      {n:'A-C3', name:'Anthony Daniels', artist:'C-3PO'},
      {n:'A-CAM', name:'Carrie-Anne Moss', artist:'Jedi Master Indara'},
      {n:'A-CARR', name:'Geneva Carr', artist:'Nooma'},
      {n:'A-CF', name:'Carrie Fisher', artist:'Leia Organa'},
      {n:'A-DB', name:'Dominic Burgess', artist:'Beef'},
      {n:'A-DBB', name:'Dee Bradley Baker', artist:'Clone Captain Rex'},
      {n:'A-DIL', name:'Richard Dillane', artist:'Davo Sculdun'},
      {n:'A-DK', name:'Dafne Keen', artist:'Jedi Padawan Jecki Lon'},
      {n:'A-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'A-DOM', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'A-DP', name:'David Prowse', artist:'Darth Vader'},
      {n:'A-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'A-DTEN', name:'David Tennant', artist:'Huyang'},
      {n:'A-EC', name:'Emilia Clarke', artist:'Qi\'ra'},
      {n:'A-EM', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'A-ES', name:'Emily Swallow', artist:'The Armorer'},
      {n:'A-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'A-FPJ', name:'Freddie Prinze Jr.', artist:'Kanan Jarrus'},
      {n:'A-FW', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'A-GC', name:'Gwendoline Christie', artist:'Captain Phasma'},
      {n:'A-GO', name:'Genevieve O\'Reilly', artist:'Mon Mothma'},
      {n:'A-HC', name:'Hayden Christensen', artist:'Anakin Skywalker'},
      {n:'A-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'A-IM', name:'Ian McDiarmid', artist:'Emperor Palpatine'},
      {n:'A-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'A-JB', name:'John Boyega', artist:'Finn'},
      {n:'A-JG', name:'Julian Glover', artist:'General Maximilian Veers'},
      {n:'A-JIM', name:'Jimmi Simpson', artist:'Royce Hemlock'},
      {n:'A-JJB', name:'Jacob James Beswick', artist:'Sergeant Heert'},
      {n:'A-JL', name:'Jude Law', artist:'Jod Na Nawood'},
      {n:'A-JO', name:'Jonjo O\'Neill', artist:'Captain Kaido'},
      {n:'A-KAT', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'A-KS', name:'Karol Cristina da Silva', artist:'Rabé'},
      {n:'A-LB', name:'Lynn Robertson Bruce', artist:'D-O'},
      {n:'A-LFA', name:'Lane Factor', artist:'Lyco Strata'},
      {n:'A-LIZ', name:'Lizzo', artist:'The Duchess of Plazir'},
      {n:'A-LJ', name:'Lee Jung-jae', artist:'Jedi Master Sol'},
      {n:'A-LM', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'A-LOO', name:'Chris Diamantopoulos', artist:'Looti Vario'},
      {n:'A-LU', name:'Lupita Nyong\'o', artist:'Maz Kanata'},
      {n:'A-MEW', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'A-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'A-MMA', name:'Marti Matulis', artist:'Vane'},
      {n:'A-MQ', name:'Mike Quinn', artist:'Sy Snootles'},
      {n:'A-MV', name:'Mario Vernazza', artist:'Vult Skerris'},
      {n:'A-MW', name:'Matthew Wood', artist:'General Grievous'},
      {n:'A-NB', name:'Natasha Liu Bordizzo', artist:'Sabine Wren'},
      {n:'A-OI', name:'Oscar Isaac', artist:'Poe Dameron'},
      {n:'A-OWE', name:'Rena Owen', artist:'Taun We'},
      {n:'A-PB', name:'Paul Bettany', artist:'Dryden Vos'},
      {n:'A-PL', name:'Phil LaMarr', artist:'Klatooinian Crime Boss'},
      {n:'A-PP', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'A-RD', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'A-RE', name:'Robert Emms', artist:'Supervisor Lonni Jung'},
      {n:'A-RH', name:'Clint Howard', artist:'Ralakili'},
      {n:'A-RO', name:'Rosalind Halstead', artist:'Runai Sculdun'},
      {n:'A-RRL', name:'Raphael Roger Levy', artist:'Senator Oran'},
      {n:'A-SH', name:'Shirley Henderson', artist:'Babu Frik'},
      {n:'A-SS', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'A-TC', name:'TC Carson', artist:'Mace Windu'},
      {n:'A-TG', name:'Thierry Godard', artist:'Lezine'},
      {n:'A-ZAC', name:'Zach Braff', artist:'Freck'},
      {n:'A-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'A-AC', name:'Aidan Cook', artist:'Bobbajo'},
      {n:'A-AM', name:'Alastair Mackenzie', artist:'Perrin Fertha'},
      {n:'A-AP', name:'Alistair Petrie', artist:'General Draven'},
      {n:'A-BB-2', name:'Benjamin Bratt', artist:'Bail Organa'},
      {n:'A-BDH', name:'Bryce Dallas Howard', artist:'Yaddle'},
      {n:'A-BL', name:'Billie Lourd', artist:'Lieutenant Connix'},
      {n:'A-BUTL', name:'Artt Butler', artist:'Niro'},
      {n:'A-CL', name:'Christopher Lloyd', artist:'Commissioner Helgait'},
      {n:'A-COYN', name:'Jonny Coyne', artist:'Lord Janu'},
      {n:'A-DBA', name:'David Barclay', artist:'Jabba the Hutt'},
      {n:'A-DGO', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'A-DI', name:'Diana Lee Inosanto', artist:'Morgan Elsbeth'},
      {n:'A-DT', name:'Dee Tails', artist:'Sidon Ithano'},
      {n:'A-ED', name:'Elizabeth Dulau', artist:'Kleya Marki'},
      {n:'A-EE', name:'Eman Esfandi', artist:'Ezra Bridger'},
      {n:'A-EW', name:'Elijah Wood', artist:'Jace Rucklin'},
      {n:'A-FG', name:'Finley Glasgow', artist:'Stekan Sculdun'},
      {n:'A-FM', name:'Faye Marsay', artist:'Vel Sartha'},
      {n:'A-GA', name:'Gideon Adlon', artist:'Devon Izara'},
      {n:'A-GAT', name:'Stephen McKinley Henderson', artist:'Gatori'},
      {n:'A-GB', name:'Gary Beadle', artist:'Clem Andor'},
      {n:'A-HAY', name:'Dennis Haysbert', artist:'Master Eeko-Dio Daki'},
      {n:'A-HER', name:'Hermione Corfield', artist:'Tallie Lintra'},
      {n:'A-IE', name:'Ian McElhinney', artist:'Jan Dodonna'},
      {n:'A-JAI', name:'Jason Isaacs', artist:'The Grand Inquisitor'},
      {n:'A-JJ', name:'Julia Jones', artist:'Omera'},
      {n:'A-JOA', name:'Joanna Bennett', artist:'Tusken Raider Warrior'},
      {n:'A-KHU', name:'Kathryn Hunter', artist:'Eedy Karn'},
      {n:'A-KO', name:'Katy O\'Brian', artist:'Elia Kane'},
      {n:'A-KRR', name:'Carey Jones', artist:'Krrsantan'},
      {n:'A-KSO', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'A-KT', name:'Kelly Marie Tran', artist:'Rose Tico'},
      {n:'A-LM-2', name:'Bronte Carmichael', artist:'Leida Mothma'},
      {n:'A-LS', name:'Leilani Shiu', artist:'Jawa'},
      {n:'A-MA', name:'Michelle Ang', artist:'Omega'},
      {n:'A-MB', name:'Mark Boone Jr.', artist:'Ranzar Malk'},
      {n:'A-MJ', name:'Manny Jacinto', artist:'The Stranger'},
      {n:'A-MNW', name:'Ming-Na Wen', artist:'Fennec Shand'},
      {n:'A-MOFF', name:'Giancarlo Esposito', artist:'Moff Gideon'},
      {n:'A-NF', name:'Nick Frost', artist:'SM-33'},
      {n:'A-NIKKA', name:'Nikka Futterman', artist:'Asajj Ventress'},
      {n:'A-NKR', name:'Nalini Krishan', artist:'Barriss Offee'},
      {n:'A-NL', name:'Nelson Lee', artist:'Hamato Xiono'},
      {n:'A-NN', name:'Nick Nolte', artist:'Kuiil'},
      {n:'A-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'A-RAY', name:'Ray Park', artist:'Darth Maul'},
      {n:'A-ROY', name:'Deep Roy', artist:'Droopy McCool'},
      {n:'A-RS', name:'Richard Sammel', artist:'Carro Rylanz'},
      {n:'A-RUSS', name:'Keri Russell', artist:'Zorii Bliss'},
      {n:'A-SG', name:'Sam Gilroy', artist:'Gerdis'},
      {n:'A-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'A-SPYB', name:'David W. Collins', artist:'Spybot'},
      {n:'A-ST', name:'Sophie Thatcher', artist:'Drash'},
      {n:'A-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'A-TO', name:'Timothy Olyphant', artist:'Cobb Vanth'},
      {n:'A-TR', name:'Tim Rose', artist:'Admiral Ackbar'},
      {n:'A-VAN', name:'Vanessa Marshall', artist:'Rook Kast'},
      {n:'A-VEE', name:'Jimmy Vee', artist:'R2-D2'},
      {n:'A-VS', name:'Varada Sethu', artist:'Cinta Kaz'},
      {n:'A-WC', name:'Wes Chatham', artist:'Captain Enoch'},
      {n:'A-WIT', name:'Sam Witwer', artist:'Maul'},
      {n:'A-XB', name:'Xander Berkeley', artist:'Captain Gilad Pellaeon'},
      {n:'A-AE', name:'Ashley Eckstein', artist:'Ahsoka Tano'},
      {n:'A-ALAW', name:'Amanda Lawrence', artist:'Commander D\'acy'},
      {n:'A-ALD', name:'Alden Ehrenreich', artist:'Han Solo'},
      {n:'A-AMY', name:'Amy Sedaris', artist:'Peli Motto'},
      {n:'A-ANP', name:'Angelique Perrin', artist:'Adi Gallia'},
      {n:'A-BAKE', name:'Tom Baker', artist:'Bendu'},
      {n:'A-BDT', name:'Benicio del Toro', artist:'DJ'},
      {n:'A-BRU', name:'Bruce Spence', artist:'Tion Medon'},
      {n:'A-BVE', name:'Brian Vernel', artist:'Bala-Tik'},
      {n:'A-CB', name:'Clancy Brown', artist:'Ryder Azadi'},
      {n:'A-CBL', name:'Claudia Black', artist:'Klothow'},
      {n:'A-CSO', name:'Marton Csokas', artist:'Poggle the Lesser'},
      {n:'A-DD', name:'Dawn Dininger', artist:'Lieutenant Beyta'},
      {n:'A-DER', name:'Laura Dern', artist:'Amilyn Holdo'},
      {n:'A-DISK', name:'Ben Diskin', artist:'AZI-3'},
      {n:'A-DMO', name:'Dominic Monaghan', artist:'Beaumont Kin'},
      {n:'A-DOY', name:'David Oyelowo', artist:'Alexsandr Kallus'},
      {n:'A-DUS', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'A-ERI', name:'Cynthia Erivo', artist:'Jedi Master Kratu'},
      {n:'A-FON', name:'Gabriel Fonseca', artist:'Duke Kayo Organa'},
      {n:'A-FSH', name:'Fiona Shaw', artist:'Maarva Andor'},
      {n:'A-GG', name:'Greg Grunberg', artist:'Snap Wexley'},
      {n:'A-GTA', name:'George Takei', artist:'Lok Durd'},
      {n:'A-GTO', name:'Gina Torres', artist:'Ketsu Onyo'},
      {n:'A-HQU', name:'Hugh Quarshie', artist:'Captain Panaka'},
      {n:'A-JAKEL', name:'Jake Lloyd', artist:'Anakin Skywalker'},
      {n:'A-JSP', name:'Jason Spisak', artist:'Lux Bonteri'},
      {n:'A-KATK', name:'Katy Kartwheel', artist:'Rio Durant'},
      {n:'A-KKN', name:'Keira Knightley', artist:'Sabé'},
      {n:'A-LBO', name:'Lee Boardman', artist:'Kravas Drezzer'},
      {n:'A-LL', name:'Lucy Liu', artist:'Bandit Leader'},
      {n:'A-MOS', name:'Moses Ingram', artist:'Reva'},
      {n:'A-PEGG', name:'Simon Pegg', artist:'Unkar Plutt'},
      {n:'A-PM', name:'Peter Mayhew', artist:'Chewbacca'},
      {n:'A-ROD', name:'Al Rodrigo', artist:'Quinlan Vos'},
      {n:'A-RON', name:'Ron Howard', artist:'Solo: A Star Wars Story'},
      {n:'A-ROP', name:'Ron Perlman', artist:'Gha Nachkt'},
      {n:'A-RUP', name:'Rupert Friend', artist:'The Grand Inquisitor'},
      {n:'A-SEB', name:'Sebastian Armesto', artist:'Lieutenant Mitaka'},
      {n:'A-SMG', name:'Sarah Michelle Gellar', artist:'Seventh Sister'},
      {n:'A-SPIN', name:'Brent Spiner', artist:'Gall Trayvis'},
      {n:'A-TAT', name:'Fred Tatasciore', artist:'Captain Brutus'},
      {n:'A-TKA', name:'Taika Waititi', artist:'IG-11'},
      {n:'A-TNEW', name:'Thandiwe Newton', artist:'Val'},
      {n:'A-TVAL', name:'Tasia Valenza', artist:'Shaak Ti'},
      {n:'A-VR', name:'Vinette Robinson', artist:'Wrobie Tyce'},
      {n:'A-WANDA', name:'Wanda Sykes', artist:'Phee Genoa'},
      {n:'A-WER', name:'Werner Herzog', artist:'The Client'},
    ],
  },
  {
    id: 'andor-season-2-autographs', type: 'auto', title: 'ANDOR SEASON 2 CHARACTERS AUTOGRAPH PARALLEL — 14 CARDS',
    parallels: [{id:'green-refractor',name:'Green Refractor',print_run:99,color:'#5fd35f'},{id:'star-wars-logofractor',name:'Star Wars LogoFractor',print_run:77,color:'#ffe27a'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'A2A-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'A2A-AL', name:'Anton Lesser', artist:'Major Partagaz'},
      {n:'A2A-ALAN', name:'Alan Tudyk', artist:'K-2SO'},
      {n:'A2A-BEN', name:'Ben Miles', artist:'Tay Kolma'},
      {n:'A2A-DG', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'A2A-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'A2A-ED', name:'Elizabeth Dulau', artist:'Kleya Marki'},
      {n:'A2A-FWT', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'A2A-GEN', name:'Genevieve O\'Reilly', artist:'Mon Mothma'},
      {n:'A2A-JJ', name:'Joshua James', artist:'Dr. Gorst'},
      {n:'A2A-JS', name:'Joplin Sibtain', artist:'Brasso'},
      {n:'A2A-KS', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'A2A-MBH', name:'Muhannad Bhaier', artist:'Wilmon Paak'},
      {n:'A2A-SKAR', name:'Stellan Skarsgård', artist:'Luthen Rael'},
    ],
  },
  {
    id: 'mando-and-grogu-autographs', type: 'auto', title: 'THE MANDALORIAN AND GROGU CHARACTERS AUTOGRAPH PARALLEL — 4 CARDS',
    parallels: [{id:'green-refractor',name:'Green Refractor',print_run:99,color:'#5fd35f'},{id:'star-wars-logofractor',name:'Star Wars LogoFractor',print_run:77,color:'#ffe27a'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'MAGR-MAN', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'MAGR-ZEB', name:'Steve Blum', artist:'Zeb Orrelios'},
      {n:'MAGR-GAT', name:'Stephen McKinley Henderson', artist:'Gatori'},
      {n:'MAGR-JAN', name:'Jonny Coyne', artist:'Lord Janu'},
    ],
  },
  {
    id: 'visions-season-3-autographs', type: 'auto', title: 'VISIONS SEASON 3 CHARACTERS AUTOGRAPH PARALLEL — 5 CARDS',
    parallels: [{id:'green-refractor',name:'Green Refractor',print_run:99,color:'#5fd35f'},{id:'star-wars-logofractor',name:'Star Wars LogoFractor',print_run:77,color:'#ffe27a'},{id:'gold-refractor',name:'Gold Refractor',print_run:50,color:'#f0c040'},{id:'orange-refractor',name:'Orange Refractor',print_run:25,color:'#ff9d52'},{id:'black-refractor',name:'Black Refractor',print_run:10,color:'#a8a8b4'},{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'V3A-KF', name:'Karen Fukuhara', artist:'F'},
      {n:'V3A-LK', name:'Liam Karlson', artist:'Yuko'},
      {n:'V3A-SH', name:'Stephanie Hsu', artist:'Crane'},
      {n:'V3A-SL', name:'Simu Liu', artist:'Lah Zhima'},
      {n:'V3A-SN', name:'Suzy Nakamura', artist:'Anée-San'},
    ],
  },
  {
    id: 'duo-autographs', type: 'auto', title: 'DUO AUTOGRAPHS — 22 CARDS',
    parallels: [{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'DUO-66', name:'Temuera Morrison / Ian McDiarmid', artist:'Clone Commander Cody / Darth Sidious'},
      {n:'DUO-AD', name:'Diego Luna / Alan Tudyk', artist:'Cassian Andor / K-2SO'},
      {n:'DUO-AJ', name:'Alden Ehrenreich / Joonas Suotamo', artist:'Han Solo / Chewbacca'},
      {n:'DUO-BD', name:'Daisy Ridley / Billy Dee Williams', artist:'Rey / Lando Calrissian'},
      {n:'DUO-BG', name:'Gwendoline Christie / Benicio del Toro', artist:'Captain Phasma / DJ'},
      {n:'DUO-DP', name:'Peter Mayhew / David Prowse', artist:'Chewbacca / Darth Vader'},
      {n:'DUO-DROIDS', name:'Anthony Daniels / Jimmy Vee', artist:'C-3PO / R2-D2'},
      {n:'DUO-DS', name:'Denise Gough / Stellan Skarsgård', artist:'Dedra Meero / Luthen Rael'},
      {n:'DUO-FETT', name:'Temuera Morrison / Daniel Logan', artist:'Jango Fett / Boba Fett'},
      {n:'DUO-FG', name:'Felicity Jones / Genevieve O\'Reilly', artist:'Jyn Erso / Mon Mothma'},
      {n:'DUO-HE', name:'Hayden Christensen / Ewan McGregor', artist:'Darth Vader / Obi-Wan Kenobi'},
      {n:'DUO-JAKKU', name:'Daisy Ridley / Simon Pegg', artist:'Rey / Unkar Plutt'},
      {n:'DUO-JH', name:'Jeremy Bulloch / Harrison Ford', artist:'Boba Fett / Han Solo'},
      {n:'DUO-JM', name:'Jennifer Beals / Ming-Na Wen', artist:'Garsa Fwip / Fennec Shand'},
      {n:'DUO-JN', name:'Jake Lloyd / Natalie Portman', artist:'Anakin Skywalker / Padmé Amidala'},
      {n:'DUO-KI', name:'Keira Knightley / Ian McDiarmid', artist:'Sabé / Senator Palpatine'},
      {n:'DUO-LM', name:'Lee Jung-jae / Manny Jacinto', artist:'Jedi Master Sol / The Stranger'},
      {n:'DUO-NA', name:'Natalie Portman / Anthony Daniels', artist:'Padmé Amidala / C-3PO'},
      {n:'DUO-SE', name:'Elizabeth Dulau / Stellan Skarsgård', artist:'Kleya Marki / Luthen Rael'},
      {n:'DUO-SI', name:'Ian McDiarmid / Samuel L. Jackson', artist:'Supreme Chancellor Palpatine / Mace Windu'},
      {n:'DUO-SOLO', name:'Adam Driver / Harrison Ford', artist:'Kylo Ren / Han Solo'},
      {n:'DUO-TG', name:'Taika Waititi / Giancarlo Esposito', artist:'IG-11 / Moff Gideon'},
    ],
  },
  {
    id: 'triple-autographs', type: 'auto', title: 'TRIPLE AUTOGRAPHS — 19 CARDS',
    parallels: [{id:'red-refractor',name:'Red Refractor',print_run:5,color:'#ff5d5d'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#ffd34d'}],
    cards: [
      {n:'TRIP-DAK', name:'Anton Lesser / Kyle Soller / Denise Gough', artist:'Major Partagaz / Syril Karn / Dedra Meero'},
      {n:'TRIP-DEG', name:'Diego Luna / Elizabeth Dulau / Genevieve O\'Reilly', artist:'Cassian Andor / Kleya Marki / Mon Mothma'},
      {n:'TRIP-DFT', name:'Dee Bradley Baker / Taylor Gray / Freddie Prinze Jr.', artist:'Rex / Ezra Bridger / Kanan Jarrus'},
      {n:'TRIP-DJJ', name:'Daisy Ridley / Joonas Suotamo / Jimmy Vee', artist:'Rey / Chewbacca / R2-D2'},
      {n:'TRIP-DKK', name:'Kyle Soller / Kathryn Hunter / Denise Gough', artist:'Syril Karn / Eedy Karn / Dedra Meero'},
      {n:'TRIP-EAP', name:'Alden Ehrenreich / Emilia Clarke / Paul Bettany', artist:'Han Solo / Qi\'ra / Dryden Vos'},
      {n:'TRIP-GAB', name:'Bronte Carmichael / Genevieve O\'Reilly / Alastair Mackenzie', artist:'Leida Mothma / Mon Mothma / Perrin Fertha'},
      {n:'TRIP-GAM', name:'Mary Elizabeth Winstead / Genevieve O\'Reilly / Anthony Daniels', artist:'Hera Syndulla / Mon Mothma / C-3PO'},
      {n:'TRIP-IRN', name:'Ian McDiarmid / Ray Park / Natalie Portman', artist:'Darth Sidious / Darth Maul / Padmé Amidala'},
      {n:'TRIP-KME', name:'Mercedes Varnado / Katee Sackhoff / Emily Swallow', artist:'Koska Reeves / Bo-Katan Kryze / The Armorer'},
      {n:'TRIP-KNJ', name:'Nick Frost / Jude Law / Kyriana Kratter', artist:'SM-33 / Jod Na Nawood / KB'},
      {n:'TRIP-OLK', name:'Keri Russell / Oscar Isaac / Lynn Robertson Bruce', artist:'Zorii Bliss / Poe Dameron / D-O'},
      {n:'TRIP-RDN', name:'Rosario Dawson / David Tennant / Natasha Liu Bordizzo', artist:'Ahsoka Tano / Huyang / Sabine Wren'},
      {n:'TRIP-RFF', name:'Riz Ahmed / Forest Whitaker / Felicity Jones', artist:'Bodhi Rook / Saw Gerrera / Jyn Erso'},
      {n:'TRIP-SDT', name:'Samuel L. Jackson / Temuera Morrison / Daniel Logan', artist:'Mace Windu / Jango Fett / Boba Fett'},
      {n:'TRIP-SKD', name:'Shirley Henderson / Keri Russell / Dave Chapman', artist:'Babu Frik / Zorii Bliss / BB-8'},
      {n:'TRIP-SLD', name:'Dave Chapman / Lynn Robertson Bruce / Shirley Henderson', artist:'BB-8 / D-O / Babu Frik'},
      {n:'TRIP-SMC', name:'Sophie Thatcher / Carey Jones / Ming-Na Wen', artist:'Drash / Krrsantan / Fennec Shand'},
      {n:'TRIP-YAVIN', name:'Mark Hamill / Harrison Ford / Peter Mayhew', artist:'Luke Skywalker / Han Solo / Chewbacca'},
    ],
  },
  {
    id: 'sketch-cards', type: 'insert', title: 'SKETCH CARDS — 173 CARDS',
    parallels: [{id:'silver-foil',name:'Silver Foil',print_run:1,color:'#d4d4dc'},{id:'gold-foil',name:'Gold Foil',print_run:1,color:'#f0c040'},{id:'black-foil',name:'Black Foil',print_run:1,color:'#a8a8b4'}],
    cards: [
      {n:'1', name:'Sketch Card', artist:'Aaron Laurich'},
      {n:'2', name:'Sketch Card', artist:'Adam Beck'},
      {n:'3', name:'Sketch Card', artist:'Adam D. Perler'},
      {n:'4', name:'Sketch Card', artist:'Alexander McCormick'},
      {n:'5', name:'Sketch Card', artist:'Allen Geneta'},
      {n:'6', name:'Sketch Card', artist:'Allen Grimes'},
      {n:'7', name:'Sketch Card', artist:'Andrew Fry'},
      {n:'8', name:'Sketch Card', artist:'Andy Tiu'},
      {n:'9', name:'Sketch Card', artist:'Anthony Pietszak'},
      {n:'10', name:'Sketch Card', artist:'Anthony Richichi'},
      {n:'11', name:'Sketch Card', artist:'Antni Ellison'},
      {n:'12', name:'Sketch Card', artist:'Arlene'},
      {n:'13', name:'Sketch Card', artist:'Ash'},
      {n:'14', name:'Sketch Card', artist:'Basak Kahraman'},
      {n:'15', name:'Sketch Card', artist:'Ben AbuSaada'},
      {n:'16', name:'Sketch Card', artist:'Benjamin Lombart'},
      {n:'17', name:'Sketch Card', artist:'Bernardo Oliveira'},
      {n:'18', name:'Sketch Card', artist:'Bistek Javier'},
      {n:'19', name:'Sketch Card', artist:'Bnfer'},
      {n:'20', name:'Sketch Card', artist:'Bobby Blakey'},
      {n:'21', name:'Sketch Card', artist:'Brandon Klein'},
      {n:'22', name:'Sketch Card', artist:'Bruce Gerlach'},
      {n:'23', name:'Sketch Card', artist:'C. Deakes'},
      {n:'24', name:'Sketch Card', artist:'Candice Clemmons'},
      {n:'25', name:'Sketch Card', artist:'Carlo Allen Victoria'},
      {n:'26', name:'Sketch Card', artist:'Carrie Craggs'},
      {n:'27', name:'Sketch Card', artist:'Charlie Cody'},
      {n:'28', name:'Sketch Card', artist:'Chenduz'},
      {n:'29', name:'Sketch Card', artist:'Chris Colyer'},
      {n:'30', name:'Sketch Card', artist:'Chris Meeks'},
      {n:'31', name:'Sketch Card', artist:'Chris Timola'},
      {n:'32', name:'Sketch Card', artist:'Christoffer Allen Victoria'},
      {n:'33', name:'Sketch Card', artist:'Court'},
      {n:'34', name:'Sketch Card', artist:'Cyrus Sherkat'},
      {n:'35', name:'Sketch Card', artist:'Dan Bergren'},
      {n:'36', name:'Sketch Card', artist:'Dan Cooney'},
      {n:'37', name:'Sketch Card', artist:'Dan Curto'},
      {n:'38', name:'Sketch Card', artist:'Dan Gorman'},
      {n:'39', name:'Sketch Card', artist:'Dan Lawler'},
      {n:'40', name:'Sketch Card', artist:'Daniel Riveron'},
      {n:'41', name:'Sketch Card', artist:'Darrin Pepe'},
      {n:'42', name:'Sketch Card', artist:'David Willingham'},
      {n:'43', name:'Sketch Card', artist:'Dawn Murphy'},
      {n:'44', name:'Sketch Card', artist:'Débora Centeio'},
      {n:'45', name:'Sketch Card', artist:'Dwayne Carpenter'},
      {n:'46', name:'Sketch Card', artist:'DYJ'},
      {n:'47', name:'Sketch Card', artist:'Dylan Riley'},
      {n:'48', name:'Sketch Card', artist:'El Smetchö'},
      {n:'49', name:'Sketch Card', artist:'Elvin A Hernandez'},
      {n:'50', name:'Sketch Card', artist:'Enso Solo'},
      {n:'51', name:'Sketch Card', artist:'Eric Lehtonen'},
      {n:'52', name:'Sketch Card', artist:'Erik Maell'},
      {n:'53', name:'Sketch Card', artist:'Erik Muller'},
      {n:'54', name:'Sketch Card', artist:'Frank A. Kadar'},
      {n:'55', name:'Sketch Card', artist:'Gabe Rogue'},
      {n:'56', name:'Sketch Card', artist:'Gary Shipman'},
      {n:'57', name:'Sketch Card', artist:'Gawanimayk'},
      {n:'58', name:'Sketch Card', artist:'George Joseph'},
      {n:'59', name:'Sketch Card', artist:'Gerry Garcia Jr'},
      {n:'60', name:'Sketch Card', artist:'Getatom'},
      {n:'61', name:'Sketch Card', artist:'Ghoulie Julie'},
      {n:'62', name:'Sketch Card', artist:'Grace Riley'},
      {n:'63', name:'Sketch Card', artist:'Greg Treize'},
      {n:'64', name:'Sketch Card', artist:'Guilherme Rocha'},
      {n:'65', name:'Sketch Card', artist:'Henrique Pirote'},
      {n:'66', name:'Sketch Card', artist:'Ian McKesson'},
      {n:'67', name:'Sketch Card', artist:'Ian Yoshio Roberts'},
      {n:'68', name:'Sketch Card', artist:'Isiah Xavier Bradley'},
      {n:'69', name:'Sketch Card', artist:'Jaime Lopez'},
      {n:'70', name:'Sketch Card', artist:'James Boyd'},
      {n:'71', name:'Sketch Card', artist:'James Harris'},
      {n:'72', name:'Sketch Card', artist:'Jamie Richards'},
      {n:'73', name:'Sketch Card', artist:'Jane Rushton'},
      {n:'74', name:'Sketch Card', artist:'Jason Christner'},
      {n:'75', name:'Sketch Card', artist:'Jason Queen'},
      {n:'76', name:'Sketch Card', artist:'Jason Saldajeno'},
      {n:'77', name:'Sketch Card', artist:'Jason Sobol'},
      {n:'78', name:'Sketch Card', artist:'Jay Manchand'},
      {n:'79', name:'Sketch Card', artist:'Jeff Ward'},
      {n:'80', name:'Sketch Card', artist:'Jeffrey C. Benitez'},
      {n:'81', name:'Sketch Card', artist:'Jenn DePaola'},
      {n:'82', name:'Sketch Card', artist:'Jenny Kim'},
      {n:'83', name:'Sketch Card', artist:'Jessica Hickman'},
      {n:'84', name:'Sketch Card', artist:'Jessica Van Dusen'},
      {n:'85', name:'Sketch Card', artist:'Jesus'},
      {n:'86', name:'Sketch Card', artist:'Jiaxin "YinShan" Sun'},
      {n:'87', name:'Sketch Card', artist:'Jim O\'Riley'},
      {n:'88', name:'Sketch Card', artist:'Jodie Rae Charity'},
      {n:'89', name:'Sketch Card', artist:'Joey Mason'},
      {n:'90', name:'Sketch Card', artist:'John "JAR" Rodriguez'},
      {n:'91', name:'Sketch Card', artist:'John Boren'},
      {n:'92', name:'Sketch Card', artist:'John Pleak'},
      {n:'93', name:'Sketch Card', artist:'John Still'},
      {n:'94', name:'Sketch Card', artist:'Jojo Hilario'},
      {n:'95', name:'Sketch Card', artist:'Jon Mangini'},
      {n:'96', name:'Sketch Card', artist:'Josh Rosland'},
      {n:'97', name:'Sketch Card', artist:'Josh Trout'},
      {n:'98', name:'Sketch Card', artist:'Joshua Whitten'},
      {n:'99', name:'Sketch Card', artist:'Julia McKenzie'},
      {n:'100', name:'Sketch Card', artist:'Jun Diaz'},
      {n:'101', name:'Sketch Card', artist:'Jungle'},
      {n:'102', name:'Sketch Card', artist:'Kang Jing'},
      {n:'103', name:'Sketch Card', artist:'Karl Jones'},
      {n:'104', name:'Sketch Card', artist:'Kevin Scott Jacobs'},
      {n:'105', name:'Sketch Card', artist:'Khloe Delnick'},
      {n:'106', name:'Sketch Card', artist:'Kris Penix'},
      {n:'107', name:'Sketch Card', artist:'Laura Inglis'},
      {n:'108', name:'Sketch Card', artist:'Layton Scarbrough'},
      {n:'109', name:'Sketch Card', artist:'Lee Lightfoot'},
      {n:'110', name:'Sketch Card', artist:'Leon Braojos'},
      {n:'111', name:'Sketch Card', artist:'LH (Lisa Hall)'},
      {n:'112', name:'Sketch Card', artist:'Limuel Pinzon'},
      {n:'113', name:'Sketch Card', artist:'Louise Draper'},
      {n:'114', name:'Sketch Card', artist:'Luke Rushton LR'},
      {n:'115', name:'Sketch Card', artist:'Marcia Dye'},
      {n:'116', name:'Sketch Card', artist:'Marlo Martos'},
      {n:'117', name:'Sketch Card', artist:'Matt Stewart'},
      {n:'118', name:'Sketch Card', artist:'Matthew Maldonado'},
      {n:'119', name:'Sketch Card', artist:'Matthew Skillern'},
      {n:'120', name:'Sketch Card', artist:'Michael Mastermaker'},
      {n:'121', name:'Sketch Card', artist:'Michael W. Foreman II'},
      {n:'122', name:'Sketch Card', artist:'Michelle Rayner'},
      {n:'123', name:'Sketch Card', artist:'Nadz'},
      {n:'124', name:'Sketch Card', artist:'Neil A Brady'},
      {n:'125', name:'Sketch Card', artist:'Neil Camera'},
      {n:'126', name:'Sketch Card', artist:'Nick Gribbon'},
      {n:'127', name:'Sketch Card', artist:'Niño John Benitez'},
      {n:'128', name:'Sketch Card', artist:'Oscar Chavez'},
      {n:'129', name:'Sketch Card', artist:'Patricio Carrasco'},
      {n:'130', name:'Sketch Card', artist:'Patrick Giles'},
      {n:'131', name:'Sketch Card', artist:'Paul Williams'},
      {n:'132', name:'Sketch Card', artist:'Phil Hassewer'},
      {n:'133', name:'Sketch Card', artist:'Phillip Trujillo'},
      {n:'134', name:'Sketch Card', artist:'R. Goto'},
      {n:'135', name:'Sketch Card', artist:'Randy Siplon'},
      {n:'136', name:'Sketch Card', artist:'Rebeca Louro'},
      {n:'137', name:'Sketch Card', artist:'Rees Chua-Finlay'},
      {n:'138', name:'Sketch Card', artist:'Rich Hennemann'},
      {n:'139', name:'Sketch Card', artist:'Rico Dela Rosa'},
      {n:'140', name:'Sketch Card', artist:'Robert Hendrickson'},
      {n:'141', name:'Sketch Card', artist:'Ross'},
      {n:'142', name:'Sketch Card', artist:'Rustico Limosinero'},
      {n:'143', name:'Sketch Card', artist:'Rusty!'},
      {n:'144', name:'Sketch Card', artist:'Rutvig Vaid'},
      {n:'145', name:'Sketch Card', artist:'Ryan Edwards'},
      {n:'146', name:'Sketch Card', artist:'Ryan Finley'},
      {n:'147', name:'Sketch Card', artist:'Ryan Johnston'},
      {n:'148', name:'Sketch Card', artist:'Ryan Olsen'},
      {n:'149', name:'Sketch Card', artist:'Ryan Thompson'},
      {n:'150', name:'Sketch Card', artist:'Sammy Gomez'},
      {n:'151', name:'Sketch Card', artist:'Sandy Meeks'},
      {n:'152', name:'Sketch Card', artist:'Scott Hattox'},
      {n:'153', name:'Sketch Card', artist:'Scribbling Joe'},
      {n:'154', name:'Sketch Card', artist:'Semra Bulut'},
      {n:'155', name:'Sketch Card', artist:'Shane McCormack'},
      {n:'156', name:'Sketch Card', artist:'Shaow Siong'},
      {n:'157', name:'Sketch Card', artist:'Snorpixel'},
      {n:'158', name:'Sketch Card', artist:'Stephane Leonardi'},
      {n:'159', name:'Sketch Card', artist:'Steve Alce'},
      {n:'160', name:'Sketch Card', artist:'Steven Smith'},
      {n:'161', name:'Sketch Card', artist:'Ted Dastick Jr'},
      {n:'162', name:'Sketch Card', artist:'Tim Shinn'},
      {n:'163', name:'Sketch Card', artist:'Tom Amici'},
      {n:'164', name:'Sketch Card', artist:'TOMA'},
      {n:'165', name:'Sketch Card', artist:'Tomoko Taniguchi'},
      {n:'166', name:'Sketch Card', artist:'Tony Riley'},
      {n:'167', name:'Sketch Card', artist:'Trent Westbrook'},
      {n:'168', name:'Sketch Card', artist:'Tyler Newcomb'},
      {n:'169', name:'Sketch Card', artist:'Veronica Louro'},
      {n:'170', name:'Sketch Card', artist:'Ward Silverman'},
      {n:'171', name:'Sketch Card', artist:'William ROGER'},
      {n:'172', name:'Sketch Card', artist:'Zach Woolsey'},
      {n:'173', name:'Sketch Card', artist:'ジェイソン (Jason)'},
    ],
  },
];
